import React, {
  Children,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import {
  Breadcrumb,
  Container,
  Row,
  Col,
  Dropdown,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import Footer from "../components/footer";
import { useNavigate, useParams } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import Header from "../../src/components/header";
import Login from "../components/Login";
import Heart from "react-heart";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import { animateScroll as scroll } from "react-scroll";
import { toast, ToastContainer } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import Loader from "../images/loader/loaderrrr.gif"
import { Helmet } from "react-helmet-async";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import FooterContentSection from "../components/FooterContentSection";

export default function Categories({seoData}) {
  let prams = useParams();
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [Compare, setCompare] = useState([]);
  const [CompareData, setCompareData] = useState([]);
  const [category, setCategory] = useState([]);
  const [res, setres] = useState();
  const [customPrice, setCustomPrice] = useState(false);
  const [customMinPrice, setCustomMinPrice] = useState("");
  const [customMaxPrice, setCustomMaxPrice] = useState("");
  const [checkBoxData, setCheckBoxData] = useState(false);

  const [conditionKey, setconditionKey] = useState([]);
  const [chipsetKey, setchipsetKey] = useState([]);
  const [brandKey, setbrandKey] = useState([]);
  const [seriesKey, setseriesKey] = useState([]);
  const [modalKey, setmodalKey] = useState([]);
  const [PriceKey, setPriceKey] = useState([]);
  const [chipset, setchipset] = useState([]);
  const [condition, setcondition] = useState([]);
  const [condition1, setcondition1] = useState([]);
  const [hide, setHide] = useState();
  const [brand, setbrand] = useState([]);
  const [series, setseries] = useState([]);
  const [model, setmodel] = useState([]);
  const [Price, setPrice] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [FilterList, setFilterList] = useState();
  const [brandShow, setBrandShow] = useState(false);
  const [chipsetShow, setChipsetShow] = useState(false);
  const [seriesShow, setSeriesShow] = useState(false);
  const [showMoreSeries, setShowMoreSeries] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [sorting, setSorting] = useState("Best Deals");
  const [sort, setSort] = useState("Featured");
  const [customFilterPrice, setCustomFilterPrice] = useState([]);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("tokenuser"));
  //Loaders
  const [showConditionLoader, setShowConditionLoader] = useState(false);
  const [showChipsetLoader, setShowChipsetLoader] = useState(false);
  const [showBrandLoader, setShowBrandLoader] = useState(false);
  const [showSeriesLoader, setShowSeriesLoader] = useState(false);
  const [showModalLoader, setShowModalLoader] = useState(false);
  const [showPriceLoader, setShowPriceLoader] = useState(false);
  const [pageOffset, setPageOffset] = useState(0);
  const [page, setPage] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState({
    popUp: false,
    id: null,
  });
  const [searchloader, setSearchLoader] = useState();
  const [newsearch, setNewsearch] = useState(false);
  const [mainloader, setMainLoader] = useState(true);
  const [sortingLoader, setSortingLoader] = useState(false);
  const [total, setTotal] = useState();
  const [selectedData, setSelectedData] = useState(null);
  const [selectedfilterdata, setSelectedFilterData] = useState(null);
  const [totalpages, setTotalPages] = useState(1);
  const [checkedPrices, setCheckedPrices] = useState({});
  const [showMore, setShowMore] = useState({
    showMore: false,
    showLess: false,
  });
  const [expandCondition, setExpandCondition] = useState(true);
  const [expandChipset, setExpandChipset] = useState(false);
  const [expandBrand, setExpandBrand] = useState(false);
  const [expandSeries, setExpandSeries] = useState(false);
  const [expandModel, setExpandModel] = useState(false);
  const [expandPrice, setExpandPrice] = useState(false);
  const [showMobileFilterSheet, setShowMobileFilterSheet] = useState(false);
  const [showMobileSortSheet, setShowMobileSortSheet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
   const [forgot, setForgot] = useState(false);
    const [signup, setSignup] = useState(false);

  // Check if desktop and set all dropdowns to open on desktop only
  useEffect(() => {
    const checkScreenSize = () => {
      const desktop = window.innerWidth > 768;
      setIsDesktop(desktop);
      
      if (desktop) {
        // Open all dropdowns on desktop
        setExpandCondition(true);
        setExpandChipset(true);
        setExpandBrand(true);
        setExpandSeries(true);
        setExpandModel(true);
        setExpandPrice(true);
      } else {
        // Keep only Condition open on mobile/tablet
        setExpandCondition(true);
        setExpandChipset(false);
        setExpandBrand(false);
        setExpandSeries(false);
        setExpandModel(false);
        setExpandPrice(false);
      }
    };

    // Check on initial load
    checkScreenSize();

    // Add resize listener
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (showMobileFilterSheet || showMobileSortSheet) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showMobileFilterSheet, showMobileSortSheet]);

  useEffect(() => {
    const chip =
      chipset?.length +
      condition1?.length +
      brand?.length +
      series?.length +
      model?.length +
      Price?.length;
    setTotal(chip);

    if (chip > 4 && !showMore.showLess) {
      setShowMore((prev) => ({
        ...prev,
        showMore: true,
      }));
    } else if (chip > 4 && showMore.showLess) {
      setShowMore((prev) => ({
        ...prev,
        showMore: false,
      }));
    } else {
      setShowMore((prev) => ({
        ...prev,
        showMore: false,
        showLess: false,
      }));
    }
  }, [chipset, condition1, brand, series, model, Price]);

  const activeFilters = [
    ...condition1.map((name, index) => ({ type: "condition", name, index })),
    ...chipset.map((name, index) => ({ type: "chipset", name, index })),
    ...brand.map((name, index) => ({ type: "brand", name, index })),
    ...series.map((name, index) => ({ type: "series", name, index })),
    ...model.map((name, index) => ({ type: "model", name, index })),
    ...Price.map((name, index) => ({ type: "price", name, index })),
  ];

  const getFilterChipLabel = (filter) => {
    if (filter.type === "price" && filter.name) {
      const { min, max } = filter.name;
      if (min && max) {
        return `$${min} - $${max}`;
      }
      if (min && !max) {
        return `$${min}+`;
      }
      if (!min && max) {
        return `$0 - $${max}`;
      }
    }
    return filter.name;
  };

  const getFilterChipKey = (filter, index) => {
    if (filter.type === "price" && filter.name) {
      const { min, max } = filter.name;
      return `${filter.type}-${min ?? "min"}-${max ?? "max"}-${index}`;
    }
    return `${filter.type}-${filter.name}-${index}`;
  };

  const SearchFilterChecknewd = (
    search,
    sort,
    isChecked,
    chipset,
    brand,
    series,
    model,
    Price,
    condition
  ) => {
    setShowConditionLoader(true);
    setMainLoader(true);

    ExportApi.GetAllcategorySerch(
      search,
      sort,
      condition,
      chipset,
      brand,
      series,
      model,
      Price,
      customFilterPrice,
      isChecked
    )
      .then((resp) => {
        let data = resp?.data?.Data;
        setTotalPages(resp?.data?.totalPages);
        setShowConditionLoader(false);
        setMainLoader(false);
        setSearchLoader(resp?.data?.Loader);

        let chipsetKeyArray = [];
        let conditionKeyArray = [];
        let brandKeyArray = [];
        let modalKeyArray = [];
        let seriesKeyArray = [];
        setres(resp?.data.filterKey);
        resp?.data.filterKey?.chipset?.map((val, i) => {
          let key = { [val]: false };
          chipsetKeyArray.push(key);
        });
        setchipsetKey([...chipsetKeyArray]);
        resp?.data?.filterKey?.condition?.map((val) => {
          if (val == 1) {
            let key = { ["New-Retail"]: false };
            conditionKeyArray.push(key);
          } else if (val == 2) {
            let key = { ["New-2nd Hand"]: false };
            conditionKeyArray.push(key);
          } else {
            let key = { ["Used"]: false };
            conditionKeyArray.push(key);
          }
        });
        setconditionKey([...conditionKeyArray]);
        resp?.data?.filterKey?.series?.map((val) => {
          let key = { [val]: false };
          seriesKeyArray.push(key);
        });
        setseriesKey([...seriesKeyArray]);
        resp?.data?.filterKey?.brands?.map((val) => {
          let key = { [val]: false };

          brandKeyArray.push(key);
        });
        setbrandKey([...brandKeyArray]);
        resp?.data?.filterKey?.model?.map((val) => {
          let key = { [val]: false };
          modalKeyArray.push(key);
        });
        setmodalKey([...modalKeyArray]);
        if (prams.name == undefined) {
          setCategory(resp?.data?.Data);
        } else {
          setCategory([]);
        }

        setCount(1);

        // const { brands, condition, chipset, series, model } =
        //   resp?.data?.filterKey || {};

        // Remove duplicates from the models using Set
        // const uniqueModels = [...new Set(model)];
        // console.log("3");
        // const checkedModels = uniqueModels.filter((val) => {
     
        //   return modalKey.some((key) => key[val]);
        // });
        // Now set the filter list with unique models and the rest of the data as is
        // setFilterList((prevState) => ({
        //   ...prevState,
        //   brands: brands,
        //   condition: condition,
        //   chipset: chipset,
        //   series: series,
        //   model: checkedModels.length > 0 ? checkedModels : uniqueModels,
        // }));
        console.log(resp,"model 1")
         setFilterList(resp?.data?.filterKey);
        const mdata = true;
        localStorage.setItem("secondData", JSON.stringify(mdata));
        if (resp.data.Message == "Data Fetched Successfully") {
          setCategory([...data]);
          setShowConditionLoader(false);
        } else {
          setCategory([]);
          setShowConditionLoader(false);
        }
      })
      .catch((err) => {
        setMainLoader(false);
        setShowConditionLoader(false);
      });
  };
  const handleMouseEnter = (id) => {
    setTooltipVisible({
      ...tooltipVisible,
      popUp: true,
      id: id,
    });
  };

  const handleRemoveFilterChip = (filter) => {
    switch (filter.type) {
      case "condition":
        return conditionKeyFilterClose(filter.index, filter.name);
      case "chipset":
        return ChipsetFilterClose(filter.index, filter.name);
      case "brand":
        return brandtFilterClose(filter.index, filter.name);
      case "series":
        return seriesFilterCsole(filter.index, filter.name);
      case "model":
        return modalFilterCsole(filter.index, filter.name);
      case "price": {
        const priceIndex = Price.indexOf(filter.name);
        if (priceIndex !== -1) {
          priceFilterClose(priceIndex, filter.name);
        }
        return;
      }
      default:
        return;
    }
  };

  const handleMouseLeave = () => {
    setTooltipVisible({
      ...tooltipVisible,
      popUp: false,
      id: null,
    });
  };

  const extractCategoryIdFromUrl = () => {
    const pathArray = window.location.pathname.split("/");
    return pathArray[pathArray.length - 1];
  };

  const handlePageClick = (event, value) => {
    setPage(value);
    setPageOffset(value);
    // setPage(selected);

    const id = extractCategoryIdFromUrl();
    const npage = value;

    // GetData(id,page + 1 );
    SearchFilterpage(value);
  };

  const currentItems = category;

  const GetData = (id, page) => {
    const compareData = localStorage.getItem("Compare");

    if (compareData) {
      let result = JSON.parse(localStorage.getItem("Compare"));
      setShowConditionLoader(true);
      setCompareData(result);
      ExportApi.GetSinglecategory(id, page)
        .then((resp) => {
          setShowConditionLoader(false);

          setTotalPages(resp?.data?.data?.totalPages);
          let chipsetKeyArray = [];
          let conditionKeyArray = [];
          let brandKeyArray = [];
          let modalKeyArray = [];
          let seriesKeyArray = [];

          setCount(1);
          setres(resp?.data.data);
          resp?.data.data?.filterKey?.chipset?.map((val, i) => {
            let key = { [val]: false };
            chipsetKeyArray.push(key);
          });
          setchipsetKey([...chipsetKeyArray]);
          resp?.data.data?.filterKey?.condition?.map((val) => {
            if (val == 1) {
              let key = { ["New-Retail"]: false };
              conditionKeyArray.push(key);
            } else if (val == 2) {
              let key = { ["New-2nd Hand"]: false };
              conditionKeyArray.push(key);
            } else {
              let key = { ["Used"]: false };
              conditionKeyArray.push(key);
            }
          });
          setconditionKey([...conditionKeyArray]);
          resp?.data.data?.filterKey?.series?.map((val) => {
            let key = { [val]: false };
            seriesKeyArray.push(key);
          });
          setseriesKey([...seriesKeyArray]);
          resp?.data.data?.filterKey?.brands?.map((val) => {
            let key = { [val]: false };

            brandKeyArray.push(key);
          });
          setbrandKey([...brandKeyArray]);
          resp?.data.data?.filterKey?.model?.map((val) => {
            let key = { [val]: false };
            modalKeyArray.push(key);
          });
          setmodalKey([...modalKeyArray]);
          let data = resp?.data?.data?.productList1;

          console.log(data , "data-16354626346532646264632646")
          for (let i = 0; i < result.length; i++) {
            const element = result[i];
            for (let index = 0; index < data.length; index++) {
              const element1 = data[index];

              if (element?._id.includes(element1?._id)) {
                data[index].isCompare = true;
              }
            }
          }
          if (prams.name == undefined) {
            setCategory([...data]);
          } else {
            setCategory([]);
          }
          // console.log(resp?.data?.data?.filterKey,"filterkey003");
          console.log(resp,"model 2")
          setFilterList(resp?.data?.filterKey);

          // Extract the fields from the response
          // const { brands, condition, chipset, series, model } =
          //   resp?.data?.filterKey || {};

          // // Remove duplicates from the models using Set
          // const uniqueModels = [...new Set(model)];
          // console.log("2");
        
          // setFilterList((prevState) => ({
          //   ...prevState,
          //   brands: brands,
          //   condition: condition,
          //   chipset: chipset,
          //   series: series,
          //   model: uniqueModels,
          // }));
        })
        .catch((err) => {
          setShowConditionLoader(false);
        });
    } else {
      const filterData = localStorage.getItem("selectedFilterData");
      if (filterData) {
        const parsedData = JSON.parse(filterData);

        const series = parsedData
          .filter((item) => item.type === "series" && item.checked)
          .map((item) => item.name);

        const chipset = parsedData
          .filter((item) => item.type === "chipset" && item.checked)
          .map((item) => item.name);

        if (chipset.length > 0) {
          SearchFilterChecknewd("", "Featured", true, chipset, []);
        } else {
          SearchFilterChecknewd("", "Featured", true, series, []);
        }
      } else {
        SearchFilterChecknewd("", "Featured", false, []);
      }
      // ExportApi.Getallproducts(page,series,chipset)
      //   .then((resp) => {

      //     setTotalPages(resp?.data?.totalPages);

      //     const data = JSON.parse(localStorage.getItem("selectedData"));

      //     // if (data) {

      //     //     SearchFilterCheck(search, sort);

      //     // } else {
      //     // SearchFilterChecknewd("", "Normal", false, []);
      //     // }

      //     // const filterData = localStorage.getItem("selectedFilterData");

      //     // if (filterData) {

      //     //   const parsedData = JSON.parse(filterData);

      //     //   const series = parsedData
      //     //     .filter((item) => item.type === "series" && item.checked)
      //     //     .map((item) => item.name);

      //     //   const chipset = parsedData
      //     //     .filter((item) => item.type === "chipset" && item.checked)
      //     //     .map((item) => item.name);

      //     //   if (chipset.length > 0) {
      //     //     SearchFilterChecknewd("", "Normal", true, chipset, []);
      //     //   } else {
      //     //     SearchFilterChecknewd("", "Normal", true, series, []);
      //     //   }
      //     // } else {
      //     //   SearchFilterChecknewd("", "Normal", false, []);
      //     // }

      //     let chipsetKeyArray = [];
      //     let conditionKeyArray = [];
      //     let brandKeyArray = [];
      //     let modalKeyArray = [];
      //     let seriesKeyArray = [];
      //     setres(resp?.data.filterKey);
      //     resp?.data.filterKey?.chipset?.map((val, i) => {
      //       let key = { [val]: false };
      //       chipsetKeyArray.push(key);
      //     });
      //     setchipsetKey([...chipsetKeyArray]);
      //     resp?.data?.filterKey?.condition?.map((val) => {
      //       if (val == 1) {
      //         let key = { ["New-Retail"]: false };
      //         conditionKeyArray.push(key);
      //       } else if (val == 2) {
      //         let key = { ["New-2nd Hand"]: false };
      //         conditionKeyArray.push(key);
      //       } else {
      //         let key = { ["Used"]: false };
      //         conditionKeyArray.push(key);
      //       }
      //     });
      //     setconditionKey([...conditionKeyArray]);
      //     resp?.data?.filterKey?.series?.map((val) => {
      //       let key = { [val]: false };
      //       seriesKeyArray.push(key);
      //     });
      //     setseriesKey([...seriesKeyArray]);
      //     resp?.data?.filterKey?.brands?.map((val) => {
      //       let key = { [val]: false };

      //       brandKeyArray.push(key);
      //     });
      //     setbrandKey([...brandKeyArray]);
      //     resp?.data?.filterKey?.model?.map((val) => {
      //       let key = { [val]: false };
      //       modalKeyArray.push(key);
      //     });
      //     setmodalKey([...modalKeyArray]);
      //     if (prams.name == undefined) {

      //       setCategory(resp?.data?.Data);
      //     } else {
      //       setCategory([]);
      //     }

      //     setCount(1);
      //     setFilterList(resp?.data?.filterKey);
      //   })
      //   .catch((err) => {

      //     setShowConditionLoader(false);
      //   });
    }
  };

  const GetData1 = (id, userid) => {
    if (localStorage.getItem("Compare")) {
      let result = JSON.parse(localStorage.getItem("Compare"));
      setCompareData(result);
      setShowConditionLoader(true);
      ExportApi.GetSinglecategory1(id, userid)
        .then((resp) => {
          setTotalPages(resp?.data?.data?.totalPages);
          let chipsetKeyArray = [];
          let conditionKeyArray = [];
          let brandKeyArray = [];
          let modalKeyArray = [];
          let seriesKeyArray = [];
          setCount(1);
          setres(resp?.data.data);
          resp?.data.data?.filterKey?.chipset?.map((val, i) => {
            let key = { [val]: false };
            chipsetKeyArray.push(key);
          });
          setchipsetKey([...chipsetKeyArray]);
          resp?.data.data?.filterKey?.condition?.map((val) => {
            if (val == 1) {
              let key = { ["New-Retail"]: false };
              conditionKeyArray.push(key);
            } else if (val == 2) {
              let key = { ["New-2nd Hand"]: false };
              conditionKeyArray.push(key);
            } else {
              let key = { ["Used"]: false };
              conditionKeyArray.push(key);
            }
          });
          setconditionKey([...conditionKeyArray]);
          resp?.data.data?.filterKey?.series?.map((val) => {
            let key = { [val]: false };
            seriesKeyArray.push(key);
          });
          setseriesKey([...seriesKeyArray]);
          resp?.data.data?.filterKey?.brands?.map((val) => {
            let key = { [val]: false };

            brandKeyArray.push(key);
          });
          setbrandKey([...brandKeyArray]);
          resp?.data.data?.filterKey?.model?.map((val) => {
            let key = { [val]: false };
            modalKeyArray.push(key);
          });
          setmodalKey([...modalKeyArray]);
          let data = resp?.data?.data?.productList1;
          for (let i = 0; i < result.length; i++) {
            const element = result[i];
            for (let index = 0; index < data.length; index++) {
              const element1 = data[index];

              if (element?._id.includes(element1?._id)) {
                data[index].isCompare = true;
              }
            }
          }
          // setTimeout(() => {
          if (prams.name == undefined) {
            setCategory([...data]);
          } else {
            setCategory([]);
          }

          // });
          // setCategory(resp?.data?.data?.productList1);

          console.log(resp,"model 3")
          setFilterList(resp?.data?.filterKey);

          // Extract the fields from the response
          // const { brands, condition, chipset, series, model } =
          //   resp?.data?.filterKey || {};

      
          // const uniqueModels = [...new Set(model)];
          // console.log("1");
        
          // setFilterList((prevState) => ({
          //   ...prevState,
          //   brands: brands,
          //   condition: condition,
          //   chipset: chipset,
          //   series: series,
          //   model: uniqueModels,
          // }));
        })
        .catch((err) => {
          setShowConditionLoader(false);
        });
    } else {
      // setShowConditionLoader(true);
      const filterData = localStorage.getItem("selectedFilterData");
      if (filterData) {
        const parsedData = JSON.parse(filterData);

        const series = parsedData
          .filter((item) => item.type === "series" && item.checked)
          .map((item) => item.name);

        const chipset = parsedData
          .filter((item) => item.type === "chipset" && item.checked)
          .map((item) => item.name);

        if (chipset.length > 0) {
          SearchFilterChecknewd("", "Featured", true, chipset, []);
        } else {
          SearchFilterChecknewd("", "Featured", true, series, []);
        }
      } else {
        SearchFilterChecknewd("", "Featured", false, []);
      }
      // ExportApi.GetSinglecategory1(id, userid)
      //   .then((resp) => {

      //     setTotalPages(resp?.data?.data?.totalPages);
      //     setShowConditionLoader(false);

      //     //     const data = JSON.parse(localStorage.getItem("selectedData"));

      //     // if (data) {

      //     //     SearchFilterCheck(search, sort);

      //     // } else {
      //     //SearchFilterChecknewd("", "Normal", false, []);
      //     // }

      //     const filterData = localStorage.getItem("selectedFilterData");

      //     if (filterData) {

      //       const parsedData = JSON.parse(filterData);

      //       const series = parsedData
      //         .filter((item) => item.type === "series" && item.checked)
      //         .map((item) => item.name);

      //       const chipset = parsedData
      //         .filter((item) => item.type === "chipset" && item.checked)
      //         .map((item) => item.name);

      //

      //       if (chipset.length > 0) {
      //         SearchFilterChecknewd("", "Normal", true, chipset, []);
      //       } else {
      //         SearchFilterChecknewd("", "Normal", true, series, []);
      //       }
      //     } else {
      //       SearchFilterChecknewd("", "Normal", false, []);
      //     }

      //     let chipsetKeyArray = [];
      //     let conditionKeyArray = [];
      //     let brandKeyArray = [];
      //     let modalKeyArray = [];
      //     let seriesKeyArray = [];
      //     setCount(1);
      //     setres(resp?.data.data);
      //     resp?.data.data?.filterKey?.chipset?.map((val, i) => {
      //       let key = { [val]: false };
      //       chipsetKeyArray.push(key);
      //     });
      //     setchipsetKey([...chipsetKeyArray]);
      //     resp?.data.data?.filterKey?.condition?.map((val) => {
      //       if (val == 1) {
      //         let key = { ["New-Retail"]: false };
      //         conditionKeyArray.push(key);
      //       } else if (val == 2) {
      //         let key = { ["New-2nd Hand"]: false };
      //         conditionKeyArray.push(key);
      //       } else {
      //         let key = { ["Used"]: false };
      //         conditionKeyArray.push(key);
      //       }
      //     });
      //     setconditionKey([...conditionKeyArray]);
      //     resp?.data.data?.filterKey?.series?.map((val) => {
      //       let key = { [val]: false };
      //       seriesKeyArray.push(key);
      //     });
      //     setseriesKey([...seriesKeyArray]);
      //     resp?.data.data?.filterKey?.brands?.map((val) => {
      //       let key = { [val]: false };

      //       brandKeyArray.push(key);
      //     });
      //     setbrandKey([...brandKeyArray]);
      //     resp?.data.data?.filterKey?.model?.map((val) => {
      //       let key = { [val]: false };
      //       modalKeyArray.push(key);
      //     });
      //     setmodalKey([...modalKeyArray]);
      //     if (prams.name == undefined) {
      //       setCategory(resp?.data?.data?.productList1);
      //     } else {
      //       setCategory([]);
      //     }

      //     setFilterList(resp?.data?.data?.filterKey);
      //   })
      //   .catch((err) => {

      //     setShowConditionLoader(false);
      //   });
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const handleFevButton = (data, id, i) => {
    if (data) {
      if (localStorage.getItem("tokenuser")) {
        HandleAddtoFevreat(
          id,
          JSON.parse(localStorage.getItem("tokenuser")).id,
          i
        );
      } else if (localStorage.getItem("admin")) {
        HandleAddtoFevreat(id, JSON.parse(localStorage.getItem("admin")).id, i);
      } else {
        handleShow();
      }
    } else {
      if (localStorage.getItem("tokenuser")) {
        setToken(JSON.parse(localStorage.getItem("tokenuser")));
        HandleRemovetoFevreat(
          id,
          JSON.parse(localStorage.getItem("tokenuser")).id,
          i
        );
      } else if (localStorage.getItem("admin")) {
        setToken(JSON.parse(localStorage.getItem("admin")));
        HandleRemovetoFevreat(
          id,
          JSON.parse(localStorage.getItem("admin")).id,
          i
        );
      } else {
        handleShow();
      }
    }
  };

  // Handle click for mobile heart icon (similar to ProductsItem.jsx)
  const handleClick = (e, val, i) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    handleFevButton(!val.isfav, val._id, i);
  };

  //Add in the Fav. List
  //data used for the fav is checked or not
  //i used for the index
  //id used for the productId
  const HandleAddtoFevreat = (id, userId, i) => {
    ExportApi.AddtoFevreat(id, userId)
      .then((resp) => {
        category[i].isfav = true;
        setCategory([...category]);
        // GetData1(prams.id, JSON.parse(localStorage.getItem("admin")).id);

        // setCategory(resp.data.data);
      })
      .catch((err) => console.log(err));
  };

  //Remove from the Fav.
  //id used for the productId
  //i used for the index
  const HandleRemovetoFevreat = (id, userId, i) => {
    ExportApi.RemovetoFevreat(id, userId)
      .then((resp) => {
        category[i].isfav = false;
        setCategory([...category]);
      })
      .catch((err) => console.log(err));
  };

  // Search Filter Api
  const SearchFilterCheck = (search, sort, isChecked, page , updatedSeries) => {
    setShowConditionLoader(true);
    setSortingLoader(true);

    ExportApi.GetAllcategorySerch(
      search,
      sort,
      condition,
      chipset,
      brand,
      updatedSeries ?? series,
      model,
      Price,
      customFilterPrice,
      isChecked,
      page
    )
      .then((resp) => {
       
        setShowConditionLoader(false);
        setSortingLoader(false);
        let data = resp?.data?.Data;
        console.log(resp?.data?.filterKey,"GetAllcategorySerch>>>99");
        setFilterList(resp?.data?.filterKey);

        setTotalPages(resp?.data?.totalPages);
        if (
          resp?.data?.Message ==
          "Negative values are not allowed for min and max."
        ) {
          toast.error("Negative values are not allowed for min and max.");
        }
        setSearchLoader(resp?.data?.Loader);
        if (resp?.data?.Message == "Data Fetched Successfully") {
          // setTimeout(() => {
          setCategory([...data]);

          setShowConditionLoader(false);
        } else {
          setCategory([]);

          setShowConditionLoader(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const SearchFilterpage = (page) => {
    setShowConditionLoader(true);
    setSortingLoader(true);

    ExportApi.GetAllcategorySerch(
      search,
      sort,
      condition,
      chipset,
      brand,
      series,
      model,
      Price,
      customFilterPrice,
      isChecked,
      page
    )
      .then((resp) => {
        console.log("GetAllcategorySerch>>>100");
        setShowConditionLoader(false);
        setSortingLoader(false);
        let data = resp?.data?.Data;

        setTotalPages(resp?.data?.totalPages);
        if (
          resp?.data?.Message ==
          "Negative values are not allowed for min and max."
        ) {
          toast.error("Negative values are not allowed for min and max.");
        }
        setSearchLoader(resp?.data?.Loader);
        if (resp?.data?.Message == "Data Fetched Successfully") {
          // setTimeout(() => {
          setCategory([...data]);

          setShowConditionLoader(false);
        } else {
          setCategory([]);

          setShowConditionLoader(false);
        }
      })
      .catch((err) => console.log(err));
  };

  // Start clear All Filter

  const clearAllFilters = async () => {
     localStorage.removeItem("selectedData");
     localStorage.removeItem("selectedFilterData");
     setPage(1);
     setShowConditionLoader(true);
     setIsChecked(false);
     setPageOffset(0);
     // setPage(0);
     setCustomMinPrice("");
     setCustomMaxPrice("");
     setCheckBoxData(false);
     setBrandShow(false);
     setSeriesShow(false);
     setModelShow(false);

     const minInput = document.getElementById("Min");
     const maxInput = document.getElementById("Max");
     if (minInput) minInput.value = "";
     if (maxInput) maxInput.value = "";

     // setPage(0);
     setCheckBoxData(false);

     //SearchFilterChecknewd("", "Normal", false,[]);
     //localStorage.removeItem("selectedData");
     const checkboxes = document.querySelectorAll('input[type="checkbox"]');
     checkboxes.forEach((checkbox) => {
       checkbox.checked = false;
     });

     if (localStorage.getItem("tokenuser")) {
       await GetData1(
         prams.slug,
         JSON.parse(localStorage.getItem("tokenuser")).id
       );
     } else if (localStorage.getItem("admin")) {
       await GetData1(
         prams.slug,
         JSON.parse(localStorage.getItem("admin")).id
       );
     } else {
       await GetData(prams.slug);
     }

     setcondition([]);
     setcondition1([]);
     setchipset([]);
     setbrand([]);
     setseries([]);
     setmodel([]);
     setPrice([]);
     setCustomFilterPrice([]);

     setShowConditionLoader(false);
   };

  const newy = JSON.parse(localStorage.getItem("newkey"));

  useEffect(() => {
    if (newy == true) {
      clearAllFilters();
    }
  }, [newy]);

  useEffect(() => {
    if (mainloader === false) {
      const data = JSON.parse(localStorage.getItem("selectedData"));
      if (selectedData) {
        if (selectedData.type === "chipset") {
          const previousChipsetIndex =
            selectedData?.index !== undefined
              ? selectedData?.index
              : selectedData?.name === "AMD"
              ? 0
              : 1;
          ChipsetFilter(
            { target: { name: selectedData?.name, checked: false } },
            previousChipsetIndex
          );
        } else if (selectedData.type === "brand") {
          BrandtFilter(
            { target: { name: selectedData?.name, checked: false } },
            selectedData?.index
          );
          if (selectedData?.index >= 6) {
            setBrandShow(true);
          }
        } else if (selectedData.type === "series") {
          seriesFilter(
            { target: { name: selectedData?.name, checked: false } },
            selectedData?.index
          );
          if (selectedData?.index >= 6) {
            setSeriesShow(true);
          }
        } else if (selectedData.type === "model") {
          modalFilter(
            { target: { name: selectedData?.name, checked: false } },
            selectedData?.index
          );
          if (selectedData?.index >= 6) {
            setModelShow(true);
          }
        }
      }
      if (data) {
        if (data.type === "chipset") {
          const chipsetIndex =
            data?.index !== undefined
              ? data?.index
              : data?.name === "AMD"
              ? 0
              : 1;
          if (!chipsetKey[chipsetIndex]) chipsetKey[chipsetIndex] = {};
          ChipsetFilter(
            { target: { name: data?.name, checked: data?.checked } },
            chipsetIndex
          );
        } else if (data.type === "brand") {
          BrandtFilter(
            { target: { name: data?.name, checked: data?.checked } },
            data?.index
          );
          if (data?.index >= 6) {
            setBrandShow(true);
          }
        } else if (data.type === "series") {
          seriesFilter(
            { target: { name: data?.name, checked: data?.checked } },
            data?.index
          );
          if (data?.index >= 6) {
            setSeriesShow(true);
          }
        } else if (data.type === "model") {
          modalFilter(
            { target: { name: data?.name, checked: data?.checked } },
            data?.index
          );
          if (data?.index >= 6) {
            setModelShow(true);
          }
        }
      }
      setSelectedData(data);
    }
  }, [localStorage.getItem("selectedData"), mainloader]);

  useEffect(() => {
    if (mainloader === false) {
      const storedData = JSON.parse(localStorage.getItem("selectedFilterData"));

      if (Array.isArray(storedData)) {
        storedData.forEach((data) => {
          if (data.type === "chipset") {
            const chipsetIndex =
              data.index !== undefined
                ? data.index
                : data.name === "AMD"
                ? 0
                : 1;
            if (!chipsetKey[chipsetIndex]) chipsetKey[chipsetIndex] = {};
            ChipsetFilter(
              { target: { name: data.name, checked: data.checked } },
              chipsetIndex
            );
          } else if (data?.type === "brand") {
            BrandtFilter(
              { target: { name: data.name, checked: data.checked } },
              data.index
            );
            if (data.index >= 6) {
              setBrandShow(true);
            }
          } else if (data?.type === "series") {
            seriesFilter(
              { target: { name: data.name, checked: data.checked } },
              data.index
            );
            if (data.index >= 6) {
              setSeriesShow(true);
            }
          } else if (data?.type === "model") {
            modalFilter(
              { target: { name: data.name, checked: data.checked } },
              data.index
            );
            if (data?.index >= 6) {
              setModelShow(true);
            }
          } else if (data?.type === "price") {
            priceFilter(
              {
                target: { checked: data.checked, min: data.min, max: data.max },
              },
              data.index
            );
          } else if (data?.type === "condition") {
            conditionKeyFilter(
              {
                target: {
                  name: data.name,
                  checked: data.checked,
                  min: data.min,
                },
              },
              data.index
            );
          }
        });
      }

      if (selectedfilterdata) {
        if (selectedfilterdata.type === "chipset") {
          const previousChipsetIndex =
            selectedfilterdata.index !== undefined
              ? selectedfilterdata.index
              : selectedfilterdata.name === "AMD"
              ? 0
              : 1;
          ChipsetFilter(
            { target: { name: selectedfilterdata.name, checked: false } },
            previousChipsetIndex
          );
        } else if (selectedfilterdata.type === "brand") {
          BrandtFilter(
            { target: { name: selectedfilterdata.name, checked: false } },
            selectedfilterdata.index
          );
          if (selectedfilterdata.index >= 6) {
            setBrandShow(true);
          }
        } else if (selectedfilterdata.type === "series") {
          seriesFilter(
            { target: { name: selectedfilterdata.name, checked: false } },
            selectedfilterdata.index
          );
          if (selectedfilterdata.index >= 6) {
            setSeriesShow(true);
          }
        } else if (selectedfilterdata.type === "model") {
          modalFilter(
            { target: { name: selectedfilterdata.name, checked: false } },
            selectedfilterdata.index
          );
          if (selectedfilterdata.index >= 6) {
            setModelShow(true);
          }
        } else if (selectedfilterdata.type === "price") {
          priceFilter(
            {
              target: {
                checked: false,
                min: selectedfilterdata.min,
                max: selectedfilterdata.max,
              },
            },
            selectedfilterdata.index
          );
        } else if (selectedfilterdata.type === "condition") {
          conditionKeyFilter(
            {
              target: {
                name: selectedfilterdata.name,
                checked: false,
                min: selectedfilterdata.min,
              },
            },
            selectedfilterdata.index
          );
        }
      }

      setSelectedFilterData(storedData);
    }
  }, [mainloader]);

  // const conditionKeyFilter = (e, i) => {
  //   setShowConditionLoader(true);
  //   //setPage(0);
  //   setPageOffset(0);
  //   setCount(0);
  //   const { name, checked, min } = e.target;
  //   let number = parseInt(min);
  //   let index = condition.indexOf(number);
  //   let index1 = condition1.indexOf(name);
  //   if (checked || index === -1 || index1 === -1) {
  //     condition.push(number);
  //     condition1.push(name);
  //     conditionKey[i][name] = checked;
  //     setcondition([...condition]);
  //     setcondition1([...condition1]);
  //     SearchFilterCheck(search, sort);
  //     setShowConditionLoader(false);
  //     setCount(1);
  //   } else {
  //     conditionKey[i][name] = checked;
  //     condition.splice(index, 1);
  //     setcondition([...condition]);
  //     condition1.splice(index1, 1);
  //     setcondition1([...condition1]);
  //     SearchFilterCheck(search, sort);
  //     setShowConditionLoader(false);
  //     setCount(1);
  //   }
  // };

  const conditionKeyFilter = (e, i) => {
    setShowConditionLoader(true);
    setPageOffset(0);
    setCount(0);

    const { name, checked, min } = e.target;
    let number = parseInt(min);
    let index = condition.indexOf(number);
    let index1 = condition1.indexOf(name);
    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    const data = {
      type: "condition",
      name: name,
      min: number,
      checked: checked,
      index: i,
    };

    if (checked || index === -1 || index1 === -1) {
      condition.push(number);
      condition1.push(name);
      conditionKey[i][name] = checked;

      // Check if the data already exists in localStorage
      const isDuplicate = storedData.some(
        (item) =>
          item.type === data.type &&
          item.name === data.name &&
          item.min === data.min &&
          item.index === data.index
      );

      if (!isDuplicate) {
        storedData.push(data);
        localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      }

      setcondition([...condition]);
      setcondition1([...condition1]);
      SearchFilterCheck(search, sort);
      setShowConditionLoader(false);
      setCount(1);
    } else {
      conditionKey[i][name] = checked;
      condition.splice(index, 1);
      condition1.splice(index1, 1);

      // Remove the item from storedData when unchecked
      storedData = storedData.filter(
        (item) =>
          !(
            item.type === data.type &&
            item.name === name &&
            item.min === number &&
            item.index === i
          )
      );

      localStorage.setItem("selectedFilterData", JSON.stringify(storedData));

      setcondition([...condition]);
      setcondition1([...condition1]);
      SearchFilterCheck(search, sort);
      setShowConditionLoader(false);
      setCount(1);
    }
  };

  // End condition Filter

  // const conditionKeyFilterClose = (i, name) => {
  //   console.log(i, name,"conditionKeyFilterClose>>>>");
  //   setPageOffset(0);

  //   localStorage.removeItem("selectedData");
  //   setShowConditionLoader(true);
  //   let index = -1;
  //   for (let i = 0; i < conditionKey.length; i++) {
  //     if (Object.keys(conditionKey[i])[0] == name) {
  //       index = i;
  //     }
  //   }
  //   console.log(index,name,"filterrrr");
  //   conditionKey[index][name] = false;
  //   condition1.splice(i, 1);
  //   condition.splice(i, 1);
  //   setcondition1([...condition1]);
  //   setcondition([...condition]);
  //   SearchFilterCheck(search, sort);
  //   setShowConditionLoader(false);
  // };
  const conditionKeyFilterClose = (i, name) => {
    //console.log(i, name, "conditionKeyFilterClose>>>>");
  
    setPageOffset(0);
    localStorage.removeItem("selectedData");
    localStorage.removeItem("selectedFilterData");
     
    setShowConditionLoader(true);
  
    let index = -1;
    for (let j = 0; j < conditionKey.length; j++) {
      if (Object.keys(conditionKey[j])[0] === name) {
        index = j;
        break;  // Break the loop once a match is found
      }
    }
  
   // console.log(index, name, "filterrrr");
  
    // If index is -1, set index to 0
    if (index === -1) {
      index = 0;  
    }
  
     //console.log(index,"index after>>");
    conditionKey[index][name] = false;
  
    condition.splice(i, 1);
    condition1.splice(i, 1);
  
    setcondition([...condition]);
    setcondition1([...condition1]);
    SearchFilterCheck(search, sort);
    setShowConditionLoader(false);
  };
  

  
  const ChipsetFilter = (e, i) => {
    setShowChipsetLoader(true);
    setPageOffset(0);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);
    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    if (checked || index === -1) {
      chipset.push(name);
      if (!chipsetKey[i]) chipsetKey[i] = {};
      chipsetKey[i][name] = checked;

      const data = {
        type: "chipset",
        name: name,
        checked: checked,
        index: i,
      };

      const isDuplicate = storedData.some(
        (item) =>
          item.type === data.type &&
          item.name === data.name &&
          item.index === data.index
      );

      if (!isDuplicate) {
        storedData.push(data);
        localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      }

      setchipset([...chipset]);
      SearchFilterCheck(search, sort);
      setShowChipsetLoader(false);
    } else {
      if (!chipsetKey[i]) chipsetKey[i] = {};
      chipsetKey[i][name] = checked;
      chipset.splice(index, 1);

      storedData = storedData.filter(
        (item) =>
          !(item.type === "chipset" && item.name === name && item.index === i)
      );

      localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      setchipset([...chipset]);
      SearchFilterCheck(search, sort);
      setShowChipsetLoader(false);
    }
  };

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [category]);

  const ChipsetFilterClose = (id, name) => {
    setPageOffset(0);
console.log(id,name,"ChipsetFilterClose>>>>");
    localStorage.removeItem("selectedData");
    setShowChipsetLoader(true);
    let index = -1;
    for (let i = 0; i < chipsetKey.length; i++) {
      if (Object.keys(chipsetKey[i])[0] == name) {
        index = i;
      }
    }
       
    chipsetKey[index][name] = false;
    chipset.splice(id, 1);
    setchipset([...chipset]);
    SearchFilterCheck(search, sort);
    setShowChipsetLoader(false);
  };

  // const BrandtFilter = (e, i) => {
  //   setShowBrandLoader(true);
  //   setPageOffset(0);
  //   const { name, checked } = e.target;
  //   if (!brandKey[i]) {
  //     brandKey[i] = {};
  //   }

  //   let index = brand.indexOf(name);
  //   if (checked) {
  //     brand.push(name);
  //     brandKey[i][name] = checked;
  //     setbrand([...brand]);
  //     SearchFilterCheck(search, sort);
  //     setShowBrandLoader(false);
  //   } else {
  //     brandKey[i][name] = checked;
  //     brand.splice(index, 1);
  //     setbrand([...brand]);
  //     SearchFilterCheck(search, sort);
  //     setShowBrandLoader(false);
  //   }
  // };

  const BrandtFilter = (e, i) => {
    setShowBrandLoader(true);
    setPageOffset(0);
    const { name, checked } = e.target;

    if (!brandKey[i]) {
      brandKey[i] = {};
    }

    let index = brand.indexOf(name);
    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    if (checked) {
      brand.push(name);
      brandKey[i][name] = checked;

      const data = {
        type: "brand",
        name: name,
        checked: checked,
        index: i,
      };

      const isDuplicate = storedData.some(
        (item) =>
          item.type === data.type &&
          item.name === data.name &&
          item.index === data.index
      );

      if (!isDuplicate) {
        storedData.push(data);
        localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      }

      setbrand([...brand]);
      SearchFilterCheck(search, sort);
      setShowBrandLoader(false);
    } else {
      brandKey[i][name] = checked;
      brand.splice(index, 1);

      storedData = storedData.filter(
        (item) =>
          !(item.type === "brand" && item.name === name && item.index === i)
      );

      localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      setbrand([...brand]);
      SearchFilterCheck(search, sort);
      setShowBrandLoader(false);
    }
  };

  const brandtFilterClose = (i, name) => {
    setPageOffset(0);

    localStorage.removeItem("selectedData");
    setShowBrandLoader(true);
    let index = -1;
    for (let i = 0; i < brandKey.length; i++) {
      if (Object.keys(brandKey[i])[0] == name) {
        index = i;
      }
    }
    brandKey[index][name] = false;
    brand.splice(i, 1);
    setbrand([...brand]);
    SearchFilterCheck(search, sort);
    setShowBrandLoader(false);
  };

  // useEffect(() => {
  //   // Fetch saved series from localStorage
  //   const savedSeries = localStorage.getItem("selectedData");
  //   if (savedSeries) {
  //     const parsedSeries = JSON.parse(savedSeries);
  //     setseries(parsedSeries);

  //     // Initialize seriesKey based on saved series
  //     const newSeriesKey = FilterList?.series?.reduce((acc, val, i) => {
  //       acc[i] = {};
  //       if (parsedSeries.includes(val)) {
  //         acc[i][val] = true;
  //       }
  //       return acc;
  //     }, {});

  //     setseriesKey(newSeriesKey || {});
  //   }
  // }, []);

  const rtx20Series = [
    "RTX 2060",
    "RTX 2060 SUPER",
    "RTX 2070",
    "RTX 2070 SUPER",
    "RTX 2080",
    "RTX 2080 TI",
  ];
  const rtx30Series = [
    "RTX 30",
    "RTX 3050",
    "RTX 3060 12G",
    "RTX 3060 8G",
    "RTX 3060 Ti",
    "RTX 3070",
    "RTX 3070 TI",
    "RTX 3080 10G",
    "RTX 3080 12G",
    "RTX 3080 TI",
    "RTX 3090",
    "RTX 3090 TI",
  ];
  const rtx40Series = [
    "RTX 40",
    "RTX 4060",
    "RTX 4060 TI 16G",
    "RTX 4060 TI 8G",
    "RTX 4070",
    "RTX 4070 SUPER",
    "RTX 4070 TI",
    "RTX 4070 TI SUPER",
    "RTX 4080",
    "RTX 4080 SUPER",
    "RTX 4090",
  ];
  const rtx50Series = ["RX 5500 XT", "RX 5600 XT", "RX 5700 XT"];
  const rtx60Series = [
    "RX 6000",
    "RX 6400",
    "RX 6500 XT",
    "RX 6600",
    "RX 6600 XT",
    "RX 6650 XT",
    "RX 6700 XT",
    "RX 6750 XT",
    "RX 6800",
    "RX 6800 XT",
    "RX 6900 XT",
    "RX 6950 XT",
  ];
  const rtx70Series = [
    "RX 7000",
    "RX 7600",
    "RX 7600 XT",
    "RX 7700 XT",
    "RX 7800XT",
    "RX 7900 XT",
    "RX 7900 XTX",
  ];

  const seriesFilter = (e, i) => {
    setShowSeriesLoader(true);
    setPageOffset(0);
    const { name, checked } = e.target;

    // Get previously applied filters
    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    // Ensure storedData is an array
    if (!Array.isArray(storedData)) {
      storedData = [];
    }

    if (name === "Select All RTX 20 Series") {
      // Define the RTX 20 series
      const rtx20Series = [
        { name: "RTX 2060", index: 0 },
        { name: "RTX 2060 SUPER", index: 1 },
        { name: "RTX 2070", index: 2 },
        { name: "RTX 2070 SUPER", index: 3 },
        { name: "RTX 2080", index: 4 },
        { name: "RTX 2080 TI", index: 5 },
      ];

      // Prepare the data to be saved to localStorage
      const seriesData = rtx20Series.map((series) => ({
        type: "series",
        name: series.name,
        checked: checked,
        index: series.index,
      }));

      const updatedData = [...storedData, ...seriesData];

      // Store the data in localStorage
      localStorage.setItem("selectedFilterData", JSON.stringify(updatedData));

      let updatedSeries = [];
      if (checked) {
        // Add all child series names
        updatedSeries = [...series, ...rtx20Series.map((s) => s.name)];

      } else {
        // Remove all child series names when unchecked
        updatedSeries = series.filter(
          (item) => !rtx20Series.some((s) => s.name === item)
        );

      }
      setseries(updatedSeries);
      SearchFilterCheck(search, sort, undefined, 0, updatedSeries);
      // window.location.reload();
    } else if (name === "Select All RTX 30 Series") {
      // Define the RTX 30 series
      const rtx30Series = [
        { name: "RTX 30", index: 6 },
        { name: "RTX 3050", index: 7 },
        { name: "RTX 3060 12G", index: 8 },
        { name: "RTX 3060 8G", index: 9 },
        { name: "RTX 3060 Ti", index: 10 },
        { name: "RTX 3070", index: 11 },
        { name: "RTX 3070 TI", index: 12 },
        { name: "RTX 3080 10G", index: 13 },
        { name: "RTX 3080 12G", index: 14 },
        { name: "RTX 3080 TI", index: 15 },
        { name: "RTX 3090", index: 16 },
        { name: "RTX 3090 TI", index: 17 },
      ];

      // Prepare the data to be saved to localStorage
      const seriesData = rtx30Series.map((series) => ({
        type: "series",
        name: series.name,
        checked: checked,
        index: series.index,
      }));

      const updatedData = [...storedData, ...seriesData];

      // Store the data in localStorage
      localStorage.setItem("selectedFilterData", JSON.stringify(updatedData));

      let updatedSeries = [];
      if (checked) {
        // Add all child series names
        updatedSeries = [...series, ...rtx30Series.map((s) => s.name)];

      } else {
        // Remove all child series names when unchecked
        updatedSeries = series.filter(
          (item) => !rtx30Series.some((s) => s.name === item)
        );

      }
      setseries(updatedSeries);
      SearchFilterCheck(search, sort, undefined, 0, updatedSeries);
    } else if (name === "Select All RTX 40 Series") {
      const rtx40Series = [
        {
          name: "RTX 40",
          index: 18,
        },
        {
          name: "RTX 4060",
          index: 19,
        },
        {
          name: "RTX 4060 TI 16G",
          index: 20,
        },
        {
          name: "RTX 4060 TI 8G",
          index: 21,
        },
        {
          name: "RTX 4070",
          index: 22,
        },
        {
          name: "RTX 4070 SUPER",
          index: 23,
        },
        {
          name: "RTX 4070 TI",
          index: 24,
        },
        {
          name: "RTX 4070 TI SUPER",
          index: 25,
        },
        {
          name: "RTX 4080",
          index: 26,
        },
        {
          name: "RTX 4080 SUPER",
          index: 27,
        },
        {
          name: "RTX 4090",
          index: 28,
        },
      ];
      const seriesData = rtx40Series.map((series) => ({
        type: "series",
        name: series.name,
        checked: checked,
        index: series.index,
      }));

      const updatedData = [...storedData, ...seriesData];

      // Store the data in localStorage
      localStorage.setItem("selectedFilterData", JSON.stringify(updatedData));

      let updatedSeries = [];
      if (checked) {
        // Add all child series names
        updatedSeries = [...series, ...rtx40Series.map((s) => s.name)];

      } else {
        // Remove all child series names when unchecked
        updatedSeries = series.filter(
          (item) => !rtx40Series.some((s) => s.name === item)
        );

      }
      setseries(updatedSeries);
      SearchFilterCheck(search, sort, undefined, 0, updatedSeries);
    } else if (name === "Select All RX 5000 Series") {
      const rtx50Series = [
        {
          name: "RX 5500 XT",
          index: 29,
        },
        {
          name: "RX 5600 XT",
          index: 30,
        },
        {
          name: "RX 5700 XT",
          index: 31,
        },
      ];

      const seriesData = rtx50Series.map((series) => ({
        type: "series",
        name: series.name,
        checked: checked,
        index: series.index,
      }));

      const updatedData = [...storedData, ...seriesData];

      // Store the data in localStorage
      localStorage.setItem("selectedFilterData", JSON.stringify(updatedData));
      let updatedSeries = [];
      if (checked) {
        // Add all child series names
        updatedSeries = [...series, ...rtx50Series.map((s) => s.name)];

      } else {
        // Remove all child series names when unchecked
        updatedSeries = series.filter(
          (item) => !rtx50Series.some((s) => s.name === item)
        );

      }
      setseries(updatedSeries);
      SearchFilterCheck(search, sort, undefined, 0, updatedSeries);
    } else if (name === "Select All RX 6000 Series") {
      const rtx60Series = [
        {
          name: "RX 6000",
          index: 32,
        },
        {
          name: "RX 6400",
          index: 33,
        },
        {
          name: "RX 6500 XT",
          index: 34,
        },
        {
          name: "RX 6600",
          index: 35,
        },
        {
          name: "RX 6600 XT",
          index: 36,
        },
        {
          name: "RX 6650 XT",
          index: 37,
        },
        {
          name: "RX 6700 XT",
          index: 38,
        },
        {
          name: "RX 6750 XT",
          index: 39,
        },
        {
          name: "RX 6800",
          index: 40,
        },
        {
          name: "RX 6800 XT",
          index: 41,
        },
        {
          name: "RX 6900 XT",
          index: 42,
        },
        {
          name: "RX 6950 XT",
          index: 43,
        },
      ];

      const seriesData = rtx60Series.map((series) => ({
        type: "series",
        name: series.name,
        checked: checked,
        index: series.index,
      }));

      const updatedData = [...storedData, ...seriesData];

      // Store the data in localStorage
      localStorage.setItem("selectedFilterData", JSON.stringify(updatedData));

      let updatedSeries = [];
      if (checked) {
        // Add all child series names
        updatedSeries = [...series, ...rtx60Series.map((s) => s.name)];

      } else {
        // Remove all child series names when unchecked
        updatedSeries = series.filter(
          (item) => !rtx60Series.some((s) => s.name === item)
        );

      }
      setseries(updatedSeries);
      SearchFilterCheck(search, sort, undefined, 0, updatedSeries);
    } else if (name === "Select All RX 7000 Series") {
      const rtx70Series = [
        {
          name: "RX 7000",
          index: 44,
        },
        {
          name: "RX 7600",
          index: 45,
        },
        {
          name: "RX 7600 XT",
          index: 46,
        },
        {
          name: "RX 7700 XT",
          index: 47,
        },
        {
          name: "RX 7800XT",
          index: 48,
        },
        {
          name: "RX 7900 XT",
          index: 49,
        },
        {
          name: "RX 7900 XTX",
          index: 50,
        },
      ];
      const seriesData = rtx70Series.map((series) => ({
        type: "series",
        name: series.name,
        checked: checked,
        index: series.index,
      }));

      const updatedData = [...storedData, ...seriesData];
      localStorage.setItem("selectedFilterData", JSON.stringify(updatedData));

      let updatedSeries = [];
      if (checked) {
        // Add all child series names
        updatedSeries = [...series, ...rtx70Series.map((s) => s.name)];

      } else {
        // Remove all child series names when unchecked
        updatedSeries = series.filter(
          (item) => !rtx70Series.some((s) => s.name === item)
        );

      }
      setseries(updatedSeries);
      SearchFilterCheck(search, sort, undefined, 0, updatedSeries);
    } else {
      // Handle individual series selection/deselection
      let index = series.indexOf(name);
      let storedData =
        JSON.parse(localStorage.getItem("selectedFilterData")) || [];

      if (!Array.isArray(storedData)) {
        storedData = [];
      }
      const data = {
        type: "series",
        name: name,
        checked: checked,
        index: i,
      };

      if (checked) {
        series.push(name);
        const objIndex = seriesKey.findIndex(obj => obj.hasOwnProperty(name));
        if (objIndex !== -1) {
          seriesKey[objIndex][name] = checked;
        }

        // Avoid duplicates in storedData
        const isDuplicate = storedData.some(
          (item) =>
            item.type === data.type &&
            item.name === data.name &&
            item.index === data.index
        );

        if (!isDuplicate) {
          storedData.push(data);
          localStorage.setItem(
            "selectedFilterData",
            JSON.stringify(storedData)
          );
        }
        setseries([...series]);
        SearchFilterCheck(search, sort);
      } else {
        const objIndex = seriesKey.findIndex(obj => obj.hasOwnProperty(name));
        if (objIndex !== -1) {
          seriesKey[objIndex][name] = checked;
        }
        series.splice(index, 1);

        // Remove the unchecked series from storedData
        storedData = storedData.filter(
          (item) =>
            !(
              item.type === data.type &&
              item.name === data.name &&
              item.index === data.index
            )
        );
        localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
        setseries([...series]);
        SearchFilterCheck(search, sort);
      }
    }

    setShowSeriesLoader(false);
  };

  const seriesFilterCsole = (i, name) => {
    setPageOffset(0);

    localStorage.removeItem("selectedData");
    setShowSeriesLoader(true);
    let index = -1;
    for (let i = 0; i < seriesKey.length; i++) {
      if (Object.keys(seriesKey[i])[0] == name) {
        index = i;
      }
    }
    seriesKey[index][name] = false;
    series.splice(i, 1);
    setseries([...series]);
    SearchFilterCheck(search, sort);
    setShowSeriesLoader(false);
  };

  // const modalFilter = (e, i) => {
  //   setShowModalLoader(true);

  //   setPageOffset(0);
  //   const { name, checked } = e.target;
  //   if (!modalKey[i]) {
  //     modalKey[i] = {};
  //   }
  //   let index = chipset.indexOf(name);
  //   if (checked) {
  //     model.push(name);
  //     modalKey[i][name] = checked;
  //     setmodel([...model]);
  //     SearchFilterCheck(search, sort);
  //     setShowModalLoader(false);
  //   } else {
  //     modalKey[i][name] = checked;
  //     model.splice(index, 1);
  //     setmodel([...model]);
  //     SearchFilterCheck(search, sort);
  //     setShowModalLoader(false);
  //   }
  // };

  const modalFilter = (e, i) => {
    setShowModalLoader(true);
    setPageOffset(0);
    const { name, checked } = e.target;

    if (!modalKey[i]) {
      modalKey[i] = {};
    }

    let index = model.indexOf(name);
    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    // Ensure storedData is an array
    if (!Array.isArray(storedData)) {
      storedData = [];
    }

    const data = {
      type: "model",
      name: name,
      checked: checked,
      index: i,
    };

    if (checked) {
      model.push(name);
      modalKey[i][name] = checked;

      // Check if the data already exists in localStorage
      const isDuplicate = storedData.some(
        (item) =>
          item.type === data.type &&
          item.name === data.name &&
          item.index === data.index
      );

      if (!isDuplicate) {
        storedData.push(data);
        localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      }

      setmodel([...model]);
      SearchFilterCheck(search, sort);
      setShowModalLoader(false);
    } else {
      modalKey[i][name] = checked;
      model.splice(index, 1);

      // Remove the item from storedData when unchecked
      storedData = storedData.filter(
        (item) =>
          !(
            item.type === data.type &&
            item.name === data.name &&
            item.index === data.index
          )
      );

      localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      setmodel([...model]);
      SearchFilterCheck(search, sort);
      setShowModalLoader(false);
    }
  };

  const modalFilterCsole = (i, name) => {
    setPageOffset(0);
    localStorage.removeItem("selectedData");
    setShowModalLoader(true);
    let index = -1;
    for (let i = 0; i < modalKey.length; i++) {
      if (Object.keys(modalKey[i])[0] == name) {
        index = i;
      }
    }
    modalKey[index][name] = false;
    model.splice(i, 1);
    setmodel([...model]);
    SearchFilterCheck(search, sort);
    setShowModalLoader(false);
  };

  // const priceFilter = (e, i) => {
  //   setShowPriceLoader(true);
  //   setPageOffset(0);
  //   const { name, checked, min, max } = e.target;
  //   let total = { min: min, max: max };
  //   if (checked) {
  //     Price.push(total);
  //     PriceKey[i] = checked;
  //     setPrice([...Price]);
  //     SearchFilterCheck(search, sort);

  //     setShowPriceLoader(false);
  //   } else {
  //     let result = Price.filter((item) => {
  //       return item.min != min;
  //     });
  //     setPrice(result);
  //     setShowConditionLoader(true);
  //     ExportApi.GetAllcategorySerch(
  //       search,
  //       sort,
  //       condition,
  //       chipset,
  //       brand,
  //       series,
  //       model,
  //       result
  //     )
  //       .then((resp) => {
  //         setShowConditionLoader(false);
  //         setCategory(resp.data.Data);
  //         setShowPriceLoader(false);
  //         setLoading(false);
  //       })
  //       .catch((err) => {

  //         setShowConditionLoader(false);
  //       });
  //   }
  // };

  const priceFilter = (e, i) => {
    setShowPriceLoader(true);
    setPageOffset(0);
    const { checked, min, max } = e.target;
    let total = { min: min, max: max };

    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    // Ensure storedData is an array
    if (!Array.isArray(storedData)) {
      storedData = [];
    }

    const data = {
      type: "price",
      checked: checked,
      min: min,
      max: max,
      index: i,
    };

    if (checked) {
      Price.push(total);
      PriceKey[i] = checked;

      // Check if the data already exists in localStorage
      const isDuplicate = storedData.some(
        (item) =>
          item.type === data.type &&
          item.min === data.min &&
          item.max === data.max &&
          item.index === data.index
      );

      if (!isDuplicate) {
        storedData.push(data);
        localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      }

      setPrice([...Price]);
      SearchFilterCheck(search, sort);
      setShowPriceLoader(false);
    } else {
      let result = Price.filter((item) => {
        return item.min !== min || item.max !== max;
      });

      PriceKey[i] = checked;

      // Remove the item from storedData when unchecked
      storedData = storedData.filter(
        (item) =>
          !(
            item.type === data.type &&
            item.min === data.min &&
            item.max === data.max &&
            item.index === data.index
          )
      );

      localStorage.setItem("selectedFilterData", JSON.stringify(storedData));
      setPrice(result);
      setShowConditionLoader(true);

      ExportApi.GetAllcategorySerch(
        search,
        sort,
        condition,
        chipset,
        brand,
        series,
        model,
        result
      )
        .then((resp) => {
          console.log("GetAllcategorySerch>>>101");
          setShowConditionLoader(false);
          setCategory(resp?.data?.Data);
          setShowPriceLoader(false);
          setLoading(false);
        })
        .catch((err) => {
          setShowConditionLoader(false);
        });
    }
  };

  // const priceFilterClose = (i, name) => {
  //   console.log(i,name,"priceFilterClose?>>>>>>>");
  //   setPageOffset(0);
  //   localStorage.removeItem("selectedData");
  //   setShowPriceLoader(true);

  //   if (name?.min && name?.max) {
  //     document.getElementById(`$${name.min} - $${name.max}`).checked = false;
  //   } else if (name?.min && !name?.max) {
  //     let checkbox = document.getElementById(`$${name.min}+`); // Updated ID format
  //     if (checkbox) {
  //       checkbox.checked = false;
  //     }
  //   }

  //   let result = Price.filter((item) => {
  //     return item.min != name.min;
  //   });

  //   setPrice([...result]);
  //   setShowConditionLoader(true);

  //   ExportApi.GetAllcategorySerch(
  //     search,
  //     sort,
  //     condition,
  //     chipset,
  //     brand,
  //     series,
  //     model,
  //     result
  //   )
  //     .then((resp) => {
  //       console.log("GetAllcategorySerch>>>102");
  //       setShowConditionLoader(false);
  //       setCategory(resp?.data?.Data);
  //       setShowPriceLoader(false);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setShowConditionLoader(false);
  //     });
  // };

  // const priceFilterClose = (i, name) => {
  //   setPageOffset(0);
  //   localStorage.removeItem("selectedData");
  //   setShowPriceLoader(true);
  
  //   // Update the checked state in React
  //   setCheckedPrices((prev) => ({
  //     ...prev,
  //     [`$${name.min} - $${name.max}`]: false, // Uncheck the price range
  //   }));
  
  //   let result = Price.filter((item) => item.min !== name.min);
  //   setPrice([...result]);
  //   setShowConditionLoader(true);
  
  //   ExportApi.GetAllcategorySerch(
  //     search,
  //     sort,
  //     condition,
  //     chipset,
  //     brand,
  //     series,
  //     model,
  //     result
  //   )
  //     .then((resp) => {
  //       setShowConditionLoader(false);
  //       setCategory(resp?.data?.Data);
  //       setShowPriceLoader(false);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setShowConditionLoader(false);
  //     });
  // };

  const priceFilterClose = (i, name) => {
    console.log(i, name, "priceFilterClose?>>>>>>>");
  
    setPageOffset(0);
    localStorage.removeItem("selectedData");
    setShowPriceLoader(true);
  
    let checkbox;
  
    if (name?.min && name?.max) {
      checkbox = document.getElementById(`$${name.min} - $${name.max}`);
    } else if (name?.min && !name?.max) {
      checkbox = document.getElementById(`$${name.min}+`);
    }
  
    // Ensure checkbox exists before setting 'checked'
    if (checkbox) {
      checkbox.checked = false;
    } else {
      console.log(`Checkbox with ID $${name?.min} - $${name?.max} not found.`);
    }
  
    let result = Price.filter((item) => {
      return item.min !== name.min;
    });
  
    setPrice([...result]);
    setShowConditionLoader(true);
  
    ExportApi.GetAllcategorySerch(
      search,
      sort,
      condition,
      chipset,
      brand,
      series,
      model,
      result
    )
      .then((resp) => {
        // console.log("GetAllcategorySerch>>>102");

        setCustomPrice(false);
setCustomMinPrice("");
setCustomMaxPrice("");
setCheckBoxData(false);

        setShowConditionLoader(false);
        setCategory(resp?.data?.Data);
        setShowPriceLoader(false);
        setLoading(false);
      })
      .catch((err) => {
        setShowConditionLoader(false);
      });
  };
  
  const handleCompare = (e, val, i) => {
    if (e) {
      val.isCompare = true;
      category[i].isCompare = true;
      setCategory([...category]);
      if (Compare.length <= 10) {
        Compare.push(val);
        setCompare([...Compare]);
        setModalShow(e);
        localStorage.setItem("Compare", JSON.stringify(Compare));
      }
    } else {
      let data;
      Compare.filter((vall, i) => {
        if (vall._id == val._id) {
          data = i;
        }
      });
      val.isCompare = false;
      category[i].isCompare = false;
      setCategory([...category]);
      Compare.splice(data, 1);
      if (Compare?.length > 0) {
        setCompare([...Compare]);
        localStorage.setItem("Compare", JSON.stringify(Compare));
      } else {
        HandleCompareClear();
      }
    }
  };

  //Show More Chipset
  const handlechipsetshowmore = (data) => {
    if (data == "More") {
      setChipsetShow(true);
    } else {
      setChipsetShow(false);
    }
  };

  //Show More Brand
  const handlebrandshowmore = (data) => {
    if (data == "More") {
      setBrandShow(true);
    } else {
      setBrandShow(false);
    }
  };

  //Show More Series
  const handleSeriesshowmore = (data) => {
    if (data == "More") {
      setSeriesShow(true);
    } else {
      setSeriesShow(false);
    }
  };

  //Show More Model
  const handlemodelshowmore = (data) => {
    if (data == "More") {
      setModelShow(true);
    } else {
      setModelShow(false);
    }
    // GetDataFilterList();
  };

  const sortOptions = [
    { label: "Best Deals", value: "Featured" },
    { label: "Lowest Price", value: "Low" },
    { label: "Highest Price", value: "High" },
    { label: "Most Popular", value: "Popular" },
  ];

  const applySort = (value, label) => {
    setPage(1);
    setPageOffset(1);
    setSorting(label);
    setSort(value);
    SearchFilterCheck(search, value);
    localStorage.setItem("selectedSortValue", value);
  };

  const handleSort = (e) => {
    const value = e.target.getAttribute("value");
    const label = e.target.innerText;
    applySort(value, label);
  };

  // Function to remove all items present in the Compare PopUp
  useEffect(() => {
    // Remove items from localStorage when the component is mounted (on page load or refresh)
    const handleBeforeUnload = () => {
      localStorage.removeItem("Compare");
      localStorage.removeItem("FavouriteProducts");
    };

    // Register beforeunload event listener to remove items on page unload/refresh
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); 
  const HandleCompareClear = () => {
    // Remove comparison and favorite product data from local storage.
    localStorage.removeItem("Compare");
    localStorage.removeItem("FavouriteProducts");

    // Clear the Compare state and close the modal.
    setCompare([]);
    setModalShow(false);

    // setSort(e.target.getAttribute("value"));
    // SearchFilterCheck(search, e.target.getAttribute("value"));
    // Depending on the user's authentication status, retrieve data accordingly.
    if (localStorage.getItem("tokenuser")) {
      GetData1(prams.slug, JSON.parse(localStorage.getItem("tokenuser")).id);
    } else if (localStorage.getItem("admin")) {
      GetData1(prams.slug, JSON.parse(localStorage.getItem("admin")).id);
    } else {
      GetData(prams.slug);
    }
  };

  // Function to remove a single product from the Compare Popup
  const handleCloseButton = (productId) => {
    // Filter out the product to be removed from the Compare state.
    let result = Compare.filter((item) => item._id != productId);

    // Update the category data to reflect that the removed product is no longer in comparison.
    let data = category;
    for (let i = 0; i < data.length; i++) {
      let element = data[i];
      if (element?._id.includes(productId)) {
        data[i].isCompare = false;
      }
    }

    // Check if there is only one product left in comparison, and close the modal if so.
    let data2 = JSON.parse(localStorage.getItem("Compare"));
    if (data2?.length == 1) {
      setModalShow(false);
    }

    // Update the state and local storage with the modified comparison data.
    setCategory([...data]);
    setCompare(result);
    localStorage.setItem("Compare", JSON.stringify(result));
  };

  useEffect(() => {
    if (Price.length > 0) {
      SearchFilterCheckn(search, sort, isChecked, page);
    }
  }, [Price]);

  // const handleCustomPrice = (e, i, data) => {
  //   const filteredValue = e.target.value.replace(/\D/g, "");

  //   if (data === "checkBox") {
  //     if (!customMinPrice || !customMaxPrice) {
  //       alert("Please enter both minimum and maximum values.");
  //       e.target.checked = false;
  //       return;
  //     }

  //     const min = customMinPrice || "0";
  //     const max = customMaxPrice || "0";

  //     if (e.target.checked) {
  //       setCheckBoxData(true);
  //       setPrice([{ min, max }]); // Triggers useEffect
  //       setPriceKey({ [i]: true });
  //       setShowPriceLoader(false);
  //     } else {
  //       setCheckBoxData(false);
  //       clearAllFilters();
  //     }
  //   } else if (data === "Min") {
  //     setCustomMinPrice(filteredValue);
  //   } else if (data === "Max") {
  //     setCustomMaxPrice(filteredValue);
  //   }
  // };

  const handleCustomPrice = (e, i, data) => {
    const filteredValue = e.target.value.replace(/\D/g, "");
  
    if (data === "checkBox") {
      if (!customMinPrice || !customMaxPrice) {
        alert("Please enter both minimum and maximum values.");
        e.target.checked = false;
        return;
      }
  
      const min = customMinPrice || "0";
      const max = customMaxPrice || "0";
  
      if (e.target.checked) {
        // Checkbox checked: Set price and filters
        setCheckBoxData(true);
        setPrice([{ min, max }]); // Set the price range
        setPriceKey({ [i]: true }); // Mark this filter as active
        setShowPriceLoader(false); // Hide price loader
      } else {
        // Checkbox unchecked: Clear filters
        setCheckBoxData(false);
        clearAllFilters(); // Reset all custom price-related filters
      }
    } else if (data === "Min") {
      // Update minimum price, ensuring only digits are set
      setCustomMinPrice(filteredValue);
    } else if (data === "Max") {
      // Update maximum price, ensuring only digits are set
      setCustomMaxPrice(filteredValue);
    }
  };
  

  const SearchFilterCheckn = (search, sort, isChecked, page) => {
    setShowConditionLoader(true);
    setSortingLoader(true);

    ExportApi.GetAllcategorySerch(
      search,
      sort,
      condition,
      chipset,
      brand,
      series,
      model,
      Price,
      customFilterPrice,
      isChecked,
      page
    )
      .then((resp) => {
        console.log("GetAllcategorySerch>>>103");
        setShowConditionLoader(false);
        setSortingLoader(false);
        let data = resp?.data?.Data;

        setTotalPages(resp?.data?.totalPages);

        if (
          resp?.data?.Message ===
          "Negative values are not allowed for min and max."
        ) {
          toast.error("Negative values are not allowed for min and max.");
        }

        setSearchLoader(resp?.data?.Loader);
        if (resp?.data?.Message === "Data Fetched Successfully") {
          setCategory([...data]);
          setShowConditionLoader(false);
        } else {
          setCategory([]);
          setShowConditionLoader(false);
        }
      })
      .catch((err) => console.log(err));
  };

  // Function to handle search filter
  const handleSearchFilter = () => {
    setPageOffset(0);
    localStorage.removeItem("selectedData");
    navigate(`/categories/${prams.slug}`);
    window.location.reload();
  };

  // Function to retrieve single user data based on UserId
  const handleSingleUserData = (UserId) => {
    ExportApi.getSingleUserData(UserId)
      .then((resp) => {
        if (resp.data.message == "user not found") {
          // If the response indicates that the user was not found, trigger a "Loginout" event.
          window.dispatchEvent(new Event("Loginout"));
        } else {
          // Handle user data if the user was found.
          // You may want to add logic here to process the user data as needed.
        }
      })
      .catch((err) => console.log(err));
  };

  // Event listener for the "Loginout" event
  window.addEventListener("Loginout", () => {
    localStorage.clear();
    navigate("/");
  });

  // Start of the first useEffect block
  useEffect(() => {
    // Event listener for the "Login" event
    window.addEventListener("Login", () => {
      if (localStorage.getItem("tokenuser")) {
        // If a user is logged in as "tokenuser", retrieve data and user information.
        GetData1(prams.slug, JSON.parse(localStorage.getItem("tokenuser")).id);
        handleSingleUserData(
          JSON.parse(localStorage.getItem("tokenuser")).id
        );
      } else if (localStorage.getItem("admin")) {
        // If an admin is logged in, retrieve data and admin information.
        GetData1(prams.slug, JSON.parse(localStorage.getItem("admin")).id);
        handleSingleUserData(
          JSON.parse(localStorage.getItem("admin")).id
        );
      }
      handleClose();
    });

    // Event listener for the "Loginout" event
    window.addEventListener("Loginout", () => {
      // Retrieve data when a user logs out.
      GetData(prams.slug);
    });
  }, []); // This useEffect runs only once since the dependency array is empty.

  // Search Filter useEffect
  useEffect(() => {
    if (prams?.name) {
      setSearch(prams?.name);
      SearchFilterCheck(prams?.name, sort);
    }
  }, []);

  // Get data for comparison from local storage
  useEffect(() => {
    if (localStorage.getItem("Compare")) {
      // If there are items in local storage for comparison, set the Compare state.
      setCompare(JSON.parse(localStorage.getItem("Compare")));
    }
  }, []);

  // Another useEffect block for data retrieval

  useEffect(() => {
    // SearchFilterChecknewd("", "Normal", false, []);
    //setMainLoader(true);
    if (localStorage.getItem("tokenuser") && localStorage.getItem("Compare")) {
      // If a user is logged in as "tokenuser", retrieve data specific to that user.
      GetData1(prams.slug, JSON.parse(localStorage.getItem("tokenuser")).id);
    } else if (
      localStorage.getItem("admin") &&
      localStorage.getItem("Compare")
    ) {
      // If an admin is logged in, retrieve data specific to that admin.
      GetData1(prams.slug, JSON.parse(localStorage.getItem("admin")).id);
    } else {
      //setMainLoader(false);

      GetData(prams.slug);
    }
    // GetDataFilterList(prams.id);
  }, []);

  // const handleCheckboxChange = () => {
  //   const updatedIsChecked = !isChecked;
  //   setIsChecked(updatedIsChecked);

  //   SearchFilterCheck(search, sort, updatedIsChecked);
  // };

  useEffect(() => {
    // Initialize checkbox state from localStorage
    const storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];
    const isAvailableNowChecked = storedData.some(
      (item) =>
        item.type === "availability" &&
        item.name === "Available Now" &&
        item.checked
    );
    setIsChecked(isAvailableNowChecked);
  }, []);

  const handleCheckboxChange = (e) => {
    const updatedIsChecked = e.target.checked;
    setIsChecked(updatedIsChecked);

    const filterData = {
      type: "availability",
      name: "Available Now",
      checked: updatedIsChecked,
    };

    // Get the current filter data from localStorage
    let storedData =
      JSON.parse(localStorage.getItem("selectedFilterData")) || [];
    if (!Array.isArray(storedData)) {
      storedData = [];
    }

    if (updatedIsChecked) {
      // Add the new filter data if it's checked
      if (
        !storedData.some(
          (item) =>
            item.type === filterData.type && item.name === filterData.name
        )
      ) {
        storedData.push(filterData);
      }
    } else {
      // Remove the filter data if it's unchecked
      storedData = storedData.filter(
        (item) =>
          !(item.type === filterData.type && item.name === filterData.name)
      );
    }

    // Update localStorage
    localStorage.setItem("selectedFilterData", JSON.stringify(storedData));

    // Trigger any other functions if necessary
    SearchFilterCheck(search, sort, updatedIsChecked);
  };

  const toggleSection = (sectionSetter, currentState) => {
    // Only collapse other sections on mobile, not on desktop
    if (!isDesktop) {
      setExpandCondition(false);
      setExpandChipset(false);
      setExpandBrand(false);
      setExpandSeries(false);
      setExpandModel(false);
      setExpandPrice(false);
    }
    sectionSetter(!currentState);
  };

  return (
    <>
      <Helmet>
        <title>{seoData?.metaTitle ?? "Categories"}</title>
        <meta name="description" content={seoData?.metaDescription ?? "Browse Our Collection"} />
        {seoData?.metaImage && <meta property="og:image" content={seoData?.metaImage} />}
      </Helmet>
      <div className="custom-font">
        <Header />
        <Container className="mt-3">
        <div
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
            justifyContent: "space-between",
            alignItems: window.innerWidth < 768 ? "flex-start" : "center",
            gap: "12px",
          }}
        >
          {/* LEFT — TITLE */}
          <h1
            style={{
              margin: 0,
              fontSize: window.innerWidth < 768 ? "20px" : "24px",
              fontWeight: "600",
              flexShrink: 0,
            }}
          >
            Browse Graphics Cards
          </h1>

          {/* RIGHT — DESCRIPTION */}
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              color: "#555",
              lineHeight: "1.5",
              maxWidth: "100%",
            }}
          >
            Explore all GPUs available on GPUwiz. Bid, ask, buy, or sell any card listed
            here—even if there's no Buy Now price yet. Use filters for brand, chipset,
            series, and condition, then rely on our Deal Score to spot the best
            price-to-performance deals fast.
          </p>
        </div>

        {showMobileFilterSheet && (
          <div
            className="mobile-filter-overlay d-lg-none"
            onClick={() => setShowMobileFilterSheet(false)}
          ></div>
        )}
        {showMobileSortSheet && (
          <>
            <div
              className="mobile-filter-overlay d-lg-none"
              onClick={() => setShowMobileSortSheet(false)}
            ></div>
            <div
              className="mobile-sort-sheet-wrapper d-lg-none"
              onClick={() => setShowMobileSortSheet(false)}
            >
              <div
                className="mobile-sort-sheet"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="mobile-sheet-header">
                  <h5 className="mb-0">Sort By</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowMobileSortSheet(false)}
                  ></button>
                </div>
                <ul className="mobile-sort-options mb-0 list-unstyled">
                  {sortOptions.map((option) => (
                    <li key={option.value}>
                      <button
                        type="button"
                        className={`mobile-sort-option ${
                          sort === option.value ? "active" : ""
                        }`}
                        onClick={() => {
                          applySort(option.value, option.label);
                          setShowMobileSortSheet(false);
                        }}
                      >
                        <span>{option.label}</span>
                        {sort === option.value && (
                          <span className="mobile-sort-check">✓</span>
                        )}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}
        {/* {showMobileFilterSheet && (
          <div className="mobile-filter-footer d-lg-none">
            <button
              className="mobile-filter-result-btn"
              onClick={() => setShowMobileFilterSheet(false)}
            >
              See Result
            </button>
          </div>
        )} */}
        <div 
          className="d-lg-none d-flex gap-3 px-2"
          style={{
            top: '72px',
            background: '#f7f7f7',
            paddingTop: '12px',
            paddingBottom: '12px',
            pointerEvents: 'auto'
          }}
        >
          <button
            className="flex-fill"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowMobileFilterSheet(true);
              setShowMobileSortSheet(false);
            }}
            style={{
              border: '1px solid #d9d9d9',
              background: '#ffffff',
              borderRadius: '4.2px',
              padding: '10px 16px',
              fontWeight: 600,
              fontSize: '15px',
              color: '#111',
              pointerEvents: 'auto',
              cursor: 'pointer'
            }}
          >
            Filter By
          </button>
          <button
            className="flex-fill"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowMobileSortSheet(true);
              setShowMobileFilterSheet(false);
            }}
            style={{
              border: '1px solid #d9d9d9',
              background: '#ffffff',
              borderRadius: '4.2px',
              padding: '10px 16px',
              fontWeight: 600,
              fontSize: '15px',
              color: '#111',
              pointerEvents: 'auto',
              cursor: 'pointer'
            }}
          >
            Sort By: {sorting === "Featured" ? "Best Deals" : sorting}
          </button>
        </div>
        <Row>
          <Col
            lg={3}
            className={`filter-sidebar ${
              showMobileFilterSheet ? "mobile-open" : "d-none d-lg-block mt-3 mb-3"
            }`}
          >
            {/* Start for the Showing Filter */}
            <div
              className="border mb-sm-5"
              style={{ marginTop: showMobileFilterSheet ? "0px" : "0px" }}
            >
              <div className="sidebar-accordian p-3">
                {showMobileFilterSheet && (
                  <div className="mobile-sheet-header d-lg-none">
                    <h5 className="mb-0">Filter By</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowMobileFilterSheet(false)}
                    ></button>
                  </div>
                )}
                {showMobileFilterSheet && (
                  <div className="mobile-active-filters d-lg-none">
                    {activeFilters.length > 0 ? (
                      <>
                        <button
                          type="button"
                          className="mobile-filter-chip clear"
                          onClick={() => clearAllFilters()}
                        >
                          Clear All
                        </button>
                        <div className="mobile-active-filters-scroll">
                          {activeFilters.map((filter, index) => (
                            <span
                              className="mobile-filter-chip"
                              key={getFilterChipKey(filter, index)}
                            >
                              {getFilterChipLabel(filter)}
                              <button
                                type="button"
                                onClick={() => handleRemoveFilterChip(filter)}
                              >
                                ×
                              </button>
                            </span>
                          ))}
                        </div>
                      </>
                    ) : (
                      <span className="mobile-filter-chip empty">
                        No filters applied
                      </span>
                    )}
                  </div>
                )}
                <div>
                  <span>{/* <b>Available </b> */}</span>
                  {/* <Form.Group className="mb-2">
                    <Form.Check
                      type="checkbox"
                      label="Available Now"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                  </Form.Group> */}
                </div>

                <div className="filter-section">
                  <button
                    type="button"
                    className="filter-section-toggle"
                    onClick={() => toggleSection(setExpandCondition, expandCondition)}
                  >
                    <span>Condition</span>
                    <span
                      className={`chevron ${expandCondition ? "open" : ""}`}
                    ></span>
                  </button>
                  {expandCondition && (
                    <div className="filter-section-body">
                      {FilterList?.condition
                        ?.filter((item) => item != 1)
                        ?.map((val, i) => {
                          const label = val === 2 ? "New" : "Used";
                          return (
                            <Form.Group className="mb-2" controlId={val} key={i}>
                              <Form.Check
                                type="checkbox"
                                checked={conditionKey[i]?.[label]}
                                onChange={(e) => conditionKeyFilter(e, i)}
                                name={label}
                                min={val}
                                label={label}
                              />
                            </Form.Group>
                          );
                        })}
                      {conditionKey?.length > 6 ? (
                        <Button className="bg-none mb-3 border-0 p-0 text-dark">
                          <span className="d-inline me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-plus-square-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                            </svg>
                          </span>{" "}
                          Show More
                        </Button>
                      ) : null}
                    </div>
                  )}
                </div>

                <div className="filter-section">
                  <button
                    type="button"
                    className="filter-section-toggle"
                    onClick={() => toggleSection(setExpandChipset, expandChipset)}
                  >
                    <span>Chipset</span>
                    <span className={`chevron ${expandChipset ? "open" : ""}`}></span>
                  </button>
                  {expandChipset && (
                    <div className="filter-section-body">
                      {(chipsetShow
                        ? FilterList?.chipset
                        : FilterList?.chipset?.slice(0, 6)
                      )?.map((val, index) => (
                        <Form.Group
                          className="mb-2"
                          controlId={val}
                          key={`${val}-${index}`}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={chipsetKey[index]?.[val]}
                            onChange={(e) => ChipsetFilter(e, index)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      ))}
                      {FilterList?.chipset?.length > 6 && (
                        <Button
                          className="bg-none mb-3 border-0 p-0 text-dark"
                          onClick={() =>
                            handlechipsetshowmore(chipsetShow ? "Less" : "More")
                          }
                        >
                          <span className="d-inline me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className={`bi ${
                                chipsetShow
                                  ? "bi-dash-square-fill"
                                  : "bi-plus-square-fill"
                              }`}
                              viewBox="0 0 16 16"
                            >
                              {chipsetShow ? (
                                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                              ) : (
                                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                              )}
                            </svg>
                          </span>{" "}
                          Show {chipsetShow ? "Less" : "More"}
                        </Button>
                      )}
                    </div>
                  )}
                </div>

                <div className="filter-section">
                  <button
                    type="button"
                    className="filter-section-toggle"
                    onClick={() => toggleSection(setExpandBrand, expandBrand)}
                  >
                    <span>Brand</span>
                    <span className={`chevron ${expandBrand ? "open" : ""}`}></span>
                  </button>
                  {expandBrand && (
                    <div className="filter-section-body">
                      {brandShow
                        ? FilterList?.brands?.map((val, i) => {
                            return (
                              <>
                                <Form.Group
                                  className="mb-2"
                                  controlId={val}
                                  key={i}
                                >
                                  <Form.Check
                                    type="checkbox"
                                    checked={brandKey[i][val]}
                                    onChange={(e) => BrandtFilter(e, i)}
                                    name={val}
                                    label={val}
                                  />
                                </Form.Group>
                              </>
                            );
                          })
                        : FilterList?.brands?.map((val, i) => {
                            return (
                              <>
                                {i < 6 ? (
                                  <Form.Group
                                    className="mb-2"
                                    controlId={val}
                                    key={i}
                                  >
                                    <Form.Check
                                      type="checkbox"
                                      checked={brandKey[i][val]}
                                      onChange={(e) => BrandtFilter(e, i)}
                                      name={val}
                                      label={val}
                                    />
                                  </Form.Group>
                                ) : null}
                              </>
                            );
                          })}
                      {brandShow ? (
                        FilterList?.brands?.length > 6 ? (
                          <Button
                            className="bg-none mb-3 border-0 p-0 text-dark"
                            onClick={() => handlebrandshowmore("Less")}
                          >
                            <span className="d-inline me-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-dash-square-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                              </svg>
                            </span>{" "}
                            Show Less
                          </Button>
                        ) : null
                      ) : FilterList?.brands?.length > 6 ? (
                        <Button
                          className="bg-none mb-3 border-0 p-0 text-dark"
                          onClick={() => handlebrandshowmore("More")}
                        >
                          <span className="d-inline me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-plus-square-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                            </svg>
                          </span>{" "}
                          Show More
                        </Button>
                      ) : null}
                    </div>
                  )}
                </div>

                <div className="filter-section">
                  <button
                    type="button"
                    className="filter-section-toggle"
                    onClick={() => toggleSection(setExpandSeries, expandSeries)}
                  >
                    <span>Series</span>
                    <span className={`chevron ${expandSeries ? "open" : ""}`}></span>
                  </button>
                  {expandSeries && (
                    <div className="filter-section-body">
                      {/* Series */}
                      <div>
                        {/* <span>
                          <b>Series</b>
                        </span> */}

                        {/* Collect all series items from FilterList that match any series group */}
                        {(() => {
                          // Check which chipset is selected
                          const isAMDSelected = chipset.includes("AMD");
                          const isNvidiaSelected = chipset.includes("Nvidia");
                          const hasChipsetFilter = chipset.length > 0;

                          // Filter series groups based on selected chipset
                          let filteredSeriesGroups = [];
                          if (hasChipsetFilter) {
                            if (isAMDSelected && !isNvidiaSelected) {
                              // Only show RX series for AMD
                              filteredSeriesGroups = [
                                { name: "Select All RX 7000 Series", items: rtx70Series },
                                { name: "Select All RX 6000 Series", items: rtx60Series },
                                { name: "Select All RX 5000 Series", items: rtx50Series },
                              ];
                            } else if (isNvidiaSelected && !isAMDSelected) {
                              // Only show RTX series for Nvidia
                              filteredSeriesGroups = [
                                { name: "Select All RTX 40 Series", items: rtx40Series },
                                { name: "Select All RTX 30 Series", items: rtx30Series },
                                { name: "Select All RTX 20 Series", items: rtx20Series },
                              ];
                            } else {
                              // Both selected or other case - show all
                              filteredSeriesGroups = [
                                { name: "Select All RTX 40 Series", items: rtx40Series },
                                { name: "Select All RTX 30 Series", items: rtx30Series },
                                { name: "Select All RTX 20 Series", items: rtx20Series },
                                { name: "Select All RX 7000 Series", items: rtx70Series },
                                { name: "Select All RX 6000 Series", items: rtx60Series },
                                { name: "Select All RX 5000 Series", items: rtx50Series },
                              ];
                            }
                          } else {
                            // No chipset selected - show all
                            filteredSeriesGroups = [
                              { name: "Select All RTX 40 Series", items: rtx40Series },
                              { name: "Select All RTX 30 Series", items: rtx30Series },
                              { name: "Select All RTX 20 Series", items: rtx20Series },
                              { name: "Select All RX 7000 Series", items: rtx70Series },
                              { name: "Select All RX 6000 Series", items: rtx60Series },
                              { name: "Select All RX 5000 Series", items: rtx50Series },
                            ];
                          }

                          // Collect all individual series items (not "Select All" checkboxes)
                          const allSeriesItems = [];
                          const allSeriesGroups = filteredSeriesGroups;

                          // Build array of all series items with their group info
                          allSeriesGroups.forEach((group) => {
                            group.items.forEach((itemName) => {
                              // Check if this item exists in FilterList?.series
                              const index = FilterList?.series?.findIndex((val) => val === itemName);
                              if (index !== -1 && index !== undefined) {
                                allSeriesItems.push({
                                  name: itemName,
                                  group: group.name,
                                  index: index,
                                });
                              }
                            });
                          });

                          const totalItems = allSeriesItems.length;

                          // Get first 10 items for default view, all items for expanded view
                          const first10Items = allSeriesItems.slice(0, 10);
                          const displayedItems = showMoreSeries ? allSeriesItems : first10Items;

                          // Get set of displayed item names for quick lookup
                          const displayedItemNames = new Set(displayedItems.map(item => item.name));

                          // Get set of groups that have items in the displayed set
                          const displayedGroups = new Set(displayedItems.map(item => item.group));

                          // Render function for series groups
                          const renderSeriesGroups = () => (
                            <>
                              {allSeriesGroups.map((group) => {
                                // Only show groups that have at least one displayed item
                                if (!displayedGroups.has(group.name)) {
                                  return null;
                                }

                                // Get items from this group that are in the displayed set
                                const groupItems = group.items
                                  .map((itemName) => {
                                    const index = FilterList?.series?.findIndex((val) => val === itemName);
                                    if (index !== -1 && index !== undefined && displayedItemNames.has(itemName)) {
                                      return { name: itemName, index };
                                    }
                                    return null;
                                  })
                                  .filter(item => item !== null);

                                return (
                                  <div key={group.name}>
                                    <Form.Check
                                      className="select-all"
                                      type="checkbox"
                                      name={group.name}
                                      checked={group.items.every((seriesName) =>
                                        series.includes(seriesName)
                                      )}
                                      onChange={(e) => seriesFilter(e, -1)}
                                      label={group.name}
                                    />

                                    {groupItems.map((item) => {
                                      const val = item.name;
                                      const i = item.index;
                                      return (
                                        <Form.Group className="mb-2" controlId={val} key={`${val}-${i}`}>
                                          <Form.Check
                                            className="checkbox-item"
                                            type="checkbox"
                                            checked={series.includes(val)}
                                            onChange={(e) => seriesFilter(e, i)}
                                            name={val}
                                            label={val}
                                          />
                                        </Form.Group>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </>
                          );

                          return (
                            <>
                              {showMoreSeries ? (
                                <div style={{ maxHeight: "580px", overflowY: "auto" }}>
                                  {renderSeriesGroups()}
                                </div>
                              ) : (
                                <div>
                                  {renderSeriesGroups()}
                                </div>
                              )}

                              {/* Show More / Show Less Button */}
                              {totalItems > 10 && (
                                <Button
                                  className="bg-none mb-3 border-0 p-0 text-dark"
                                  onClick={() => setShowMoreSeries(!showMoreSeries)}
                                >
                                  <span className="d-inline me-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className={showMoreSeries ? "bi bi-dash-square-fill" : "bi bi-plus-square-fill"}
                                      viewBox="0 0 16 16"
                                    >
                                      {showMoreSeries ? (
                                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                                      ) : (
                                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                                      )}
                                    </svg>
                                  </span>{" "}
                                  Show {showMoreSeries ? "Less" : "More"}
                                </Button>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  )}
                </div>

                <div className="filter-section">
                  <button
                    type="button"
                    className="filter-section-toggle"
                    onClick={() => toggleSection(setExpandModel, expandModel)}
                  >
                    <span>Model</span>
                    <span className={`chevron ${expandModel ? "open" : ""}`}></span>
                  </button>
                  {expandModel && (
                    <div className="filter-section-body">
                      {modelShow ? (
                        <div style={{ maxHeight: "580px", overflowY: "auto" }}>
                          {FilterList?.model?.map((val, i) => {
                            return (
                              <Form.Group className="mb-2" controlId={val} key={i}>
                                <Form.Check
                                  type="checkbox"
                                  checked={modalKey[i][val]}
                                  onChange={(e) => modalFilter(e, i)}
                                  name={val}
                                  label={val}
                                />
                              </Form.Group>
                            );
                          })}
                        </div>
                      ) : (
                        <div>
                          {FilterList?.model?.map((val, i) => {
                            return i < 10 ? (
                              <Form.Group className="mb-2" controlId={val} key={i}>
                                <Form.Check
                                  type="checkbox"
                                  checked={modalKey[i][val]}
                                  onChange={(e) => modalFilter(e, i)}
                                  name={val}
                                  label={val}
                                />
                              </Form.Group>
                            ) : null;
                          })}
                        </div>
                      )}
                      {FilterList?.model?.length > 15 && (
                        <Button
                          className="bg-none mb-3 border-0 p-0 text-dark"
                          onClick={() => setModelShow((prev) => !prev)}
                        >
                          <span className="d-inline me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className={` ${
                                modelShow
                                  ? "bi bi-dash-square-fill"
                                  : "bi bi-plus-square-fill"
                              }`}
                              viewBox="0 0 16 16"
                            >
                              {modelShow ? (
                                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                              ) : (
                                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                              )}
                            </svg>
                          </span>
                          Show {modelShow ? "Less" : "More"}
                        </Button>
                      )}
                    </div>
                  )}
                </div>

                <div className="filter-section">
                  <button
                    type="button"
                    className="filter-section-toggle"
                    onClick={() => toggleSection(setExpandPrice, expandPrice)}
                  >
                    <span>Price</span>
                    <span className={`chevron ${expandPrice ? "open" : ""}`}></span>
                  </button>
                  {expandPrice && (
                    <div className="filter-section-body">
                      <>
                        <Form.Group className="mb-2">
                          <Form.Check
                            type="checkbox"
                            onChange={(e) => {
                              priceFilter(e, 0);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                            min="0"
                            max="300"
                            id="$0 - $300"
                            label="$0 to $300"
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Check
                            type="checkbox"
                            onChange={(e) => {
                              priceFilter(e, 1);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                            min="300"
                            max="500"
                            id="$300 - $500"
                            label="$300 to $500"
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Check
                            type="checkbox"
                            onChange={(e) => {
                              priceFilter(e, 2);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                            min="500"
                            max="700"
                            id="$500 - $700"
                            label="$500 to $700"
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Check
                            type="checkbox"
                            onChange={(e) => {
                              priceFilter(e, 3);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                            min="700"
                            max="900"
                            id="$700 - $900"
                            label="$700 to $900"
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Check
                            type="checkbox"
                            onChange={(e) => {
                              priceFilter(e, 4);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                            min="900"
                            id="$900+"
                            label="$900+"
                          />
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Row className="custom-price-row" style={{ gap: "0px" }}>
                             <Col md={1}>
                               <Form.Check
                                 type="checkbox"
                                 id="custom"
                                 onChange={(e) =>
                                   handleCustomPrice(e, 5, "checkBox")
                                 }
                                 checked={checkBoxData}
                               />
                             </Col>
                             {customPrice ? (
                               <>
                                 <Col md={5}>
                                   <Form.Control placeholder="$" disabled />
                                 </Col>
                                 <Col md={5}>
                                   <Form.Control placeholder="$" disabled />
                                 </Col>
                               </>
                             ) : (
                               <>
                                 <Col md={5}>
                                   <Form.Control
                                     id="Min"
                                     min="0"
                                     type="text"
                                     onChange={(e) => handleCustomPrice(e, 5, "Min")}
                                     pattern="\d*"
                                     title="Only numbers are allowed"
                                     value={customMinPrice}
                                   />
                                 </Col>
                                 <Col md={5}>
                                   <Form.Control
                                     id="Max"
                                     min="0"
                                     type="text"
                                     onChange={(e) => handleCustomPrice(e, 5, "Max")}
                                     pattern="\d*"
                                     title="Only numbers are allowed"
                                     value={customMaxPrice}
                                   />
                                 </Col>
                               </>
                             )}
                           </Row>
                        </Form.Group>
                      </>
                      {FilterList?.pricee?.length > 5 ? (
                        <Button className="bg-none border-0 p-0 text-dark">
                          <span className="d-inline me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-plus-square-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                            </svg>
                          </span>{" "}
                          Show More
                        </Button>
                      ) : null}
                    </div>
                  )}
                </div>

                {showMobileFilterSheet && (
          <div className="mobile-filter-footer d-lg-none">
            <button
              className="mobile-filter-result-btn"
              onClick={() => setShowMobileFilterSheet(false)}
            >
              See Result
            </button>
          </div>
        )}

                
              </div>
            </div>
            {/* End Showing Filter */}
          </Col>
          <Col lg={9}>
            {/* <div className="d-sm-flex justify-content-between text-center">
              <div>
                <Breadcrumb className="mt-3 mt-sm-0">
                  <Breadcrumb.Item
                    className="fs-5"
                    onClick={(e) => navigate(`/`)}
                  >
                    Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="fs-5">
                    {category ? category[0]?.category?.name : null}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </div> */}
            {/* Start Clear All Filter and Sort By - Single Line (Desktop) */}
            <div className="d-none d-lg-flex justify-content-between align-items-center gap-2 mt-3 mb-3">
              <div className="d-flex flex-wrap gap-2 align-items-center">
                {activeFilters.length > 0 && (
                  <Button
                    className="rounded-0 bg-white border text-dark py-2 fw-bold d-flex"
                    onClick={() => clearAllFilters()}
                  >
                    Clear all filters
                  </Button>
                )}

              {prams.name ? (
                <span
                  className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6  ${
                    !showMore.showLess ? "custom-childspan" : ""
                  }`}
                >
                  {prams?.name}
                  <Button
                    className="bg-none border-0 py-0 text-dark"
                    onClick={handleSearchFilter}
                  >
                    X
                  </Button>
                </span>
              ) : null}

              {conditionKey?.map((val, i) => {
                let key = condition1[i];
                let data = conditionKey.filter((item) => item[key] == true);
                return (
                  <>
                    {data.length != 0 ? (
                      <span
                        key={i}
                        className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6  ${
                          !showMore.showLess ? "custom-childspan" : ""
                        }`}
                      >
                        {condition1[i]}
                        <Button
                          className="bg-none border-0 py-0 text-dark"
                          onClick={() =>
                            conditionKeyFilterClose(i, condition1[i])
                          }
                        >
                          X
                        </Button>
                      </span>
                    ) : null}
                  </>
                );
              })}
              {chipsetKey?.map((val, i) => {
                let key = chipset[i];
                let data = chipsetKey.filter((item) => item[key] == true);
                return (
                  <>
                    {data.length != 0 ? (
                      <>
                        <span
                          key={i}
                          className={`bg-custom-light border px-3 py-2 text-center  fw-500 fs-6  ${
                            !showMore.showLess ? "custom-childspan" : ""
                          }`}
                        >
                          {chipset[i]}
                          <Button
                            className="bg-none border-0 py-0 text-dark"
                            onClick={() => ChipsetFilterClose(i, chipset[i])}
                          >
                            X
                          </Button>
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
              {brandKey?.map((val, i) => {
                let key = brand[i];
                let data = brandKey.filter((item) => item[key] == true);
                return (
                  <>
                    {data.length != 0 ? (
                      <span
                        key={i}
                        className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6  ${
                          !showMore.showLess ? "custom-childspan" : ""
                        }`}
                      >
                        {brand[i]}{" "}
                        <Button
                          className="bg-none border-0 py-0 text-dark"
                          onClick={() => brandtFilterClose(i, brand[i])}
                        >
                          X
                        </Button>
                      </span>
                    ) : null}
                  </>
                );
              })}

              {series?.map((val, i) => {
                return (
                  <span
                    key={i}
                    className={`bg-custom-light border px-3 py-2 text-center  fw-500 fs-6  ${!showMore.showLess ? "custom-childspan" : ""
                      }`}
                  >
                    {val}
                    <Button
                      className="bg-none border-0 py-0 text-dark"
                      onClick={() => seriesFilterCsole(i, val)}
                    >
                      X
                    </Button>
                  </span>
                );
              })}
              {modalKey?.map((val, i) => {
                let key = model[i];
                let data = modalKey.filter((item) => item[key] == true);
                return (
                  <>
                    {data.length != 0 ? (
                      <span
                        key={i}
                        className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6  ${
                          !showMore.showLess ? "custom-childspan" : ""
                        }`}
                      >
                        {model[i]}{" "}
                        <Button
                          className="bg-none border-0 py-0 text-dark"
                          onClick={() => modalFilterCsole(i, model[i])}
                        >
                          X
                        </Button>
                      </span>
                    ) : null}
                  </>
                );
              })}
              {Price?.map((val, i) => {
                let key = Price[i].min;
                return (
                  <>
                    {val ? (
                      <span
                        key={i}
                        className={`bg-custom-light border px-3 py-2 text-center  fw-500 fs-6 ${
                          !showMore.showLess ? "custom-childspan" : ""
                        }`}
                      >
                        {Price[i]?.min && Price[i]?.max
                          ? `$${Price[i]?.min} - $${Price[i]?.max}`
                          : `$${Price[i]?.min}+`}
                        <Button
                          className="bg-none border-0 py-0 text-dark"
                          onClick={() => priceFilterClose(i, val)}
                        >
                          X
                        </Button>
                      </span>
                    ) : null}
                  </>
                );
              })}

              {showMore.showMore && (
                <button
                  className="btn btn-link"
                  onClick={() =>
                    setShowMore((prev) => ({
                      ...prev,
                      showMore: false,
                      showLess: true,
                    }))
                  }
                >
                  Show More
                </button>
              )}
              {showMore.showLess && (
                <button
                  className="btn btn-link"
                  onClick={() =>
                    setShowMore((prev) => ({
                      ...prev,
                      showLess: false,
                      showMore: true,
                    }))
                  }
                >
                  Show Less
                </button>
              )}
              </div>
              <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="rounded-0 bg-white border text-dark py-2 fw-bold"
                    id="dropdown-basic"
                  >
                    Sort By: {sorting}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="rounded-0 w-100 mt-2"
                    onClick={(e) => handleSort(e)}
                  >
                    <Dropdown.Item value="Featured">Best Deals</Dropdown.Item>
                    <Dropdown.Item value="Low">Lowest Price</Dropdown.Item>
                    <Dropdown.Item value="High">Highest Price</Dropdown.Item>
                    <Dropdown.Item value="Popular">Most Popular</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            {/* end Clear All Filter and Sort By */}
            {/* Start for Showing the Product */}

            {showConditionLoader ||
            showChipsetLoader ||
            showBrandLoader ||
            showSeriesLoader ||
            showModalLoader ||
              showPriceLoader ||
              // count == 0
              sortingLoader ||
              mainloader == true ? (
              <div className="loader-icon d-flex justify-content-center align-items-center" style={{ height: '100vh', width: '100%' }}>
                <div className="flex justify-center items-center">
                  <img src={Loader} alt="Loading..." style={{ height: '80px' }} />
                </div>
              </div>
            ) : (
              <div>
                <div className="product-divide mt-3 mb-5" style={{ width: '100%', maxWidth: '100%', overflow: 'visible', boxSizing: 'border-box' }}>
                  {currentItems?.length > 0 ? (
                    currentItems.map((val, i) => (
                      <div
                        key={i}
                        className="categeory_page product_homepage_card inner-pro-cont border px-3 pt-3 pb-0 position-relative"
                        style={{ overflow: "visible" }}
                      >
                        {val.chipset == "Nvidia" ? (
                          <p className="up-text position-absolute fw-bold" style={{ color: 'rgba(0, 102, 0, 0.5)', zIndex: 10, pointerEvents: 'none' }}>
                            {val?.chipset}
                          </p>
                        ) : val.chipset == "AMD" ? (
                          <p className="chipset-text position-absolute fw-bold" style={{ color: 'rgba(153, 0, 0, 0.5)', zIndex: 10, pointerEvents: 'none' }}>
                            {val?.chipset}
                          </p>
                        ) : val.chipset == "AYU" ? (
                          <p className="up-down-text position-absolute fw-bold" style={{ zIndex: 10, pointerEvents: 'none' }}>
                            {val?.chipset}
                          </p>
                        ) : (
                          <p className="chipset-text position-absolute fw-bold" style={{ zIndex: 10, pointerEvents: 'none' }}>
                            {val?.chipset}
                          </p>
                        )}

                        {/* Desktop Layout */}
                        <div  className="product-card-desktop d-block">
                          <div className="product-card-desktop-child">
                            <div
                          className=""
                            onClick={() =>
                              window.open(`/product/${val?.slug}`, "_blank")
                            }
                            onContextMenu={(e) => {
                              e.preventDefault();
                              window.open(`/product/${val.slug}`, "_blank");
                            }}
                            style={{ position: "relative" }}
                          >
                            <div className="-text-center -image_parent product-image-wrapper-category mb-2 mt-2 d-flex align-items-center justify-content-center p-0">
                              <LazyLoadImage
                                src={`${val?.image[0]}`}
                                effect="blur"
                              />{" "}
                              <style>
                                {
                                  `
                                  .lazy-load-image-loaded {
    height: 100% !important;
    width: 100% !important;
    object-fit: contain;
  }
  
  .lazy-load-image-loaded img {
    height: 100% !important;
    width: 100% !important;
    object-fit: contain;
  }
                                `
                                }
                              </style>
                            </div>
                          </div>
                          <div 
                           onClick={() =>
                              window.open(`/product/${val?.slug}`, "_blank")
                            }
                             className="combine_details">
                            <div>
                              <p  className="d-flex align-items-center justify-content-between w-100 mb-0 product-title-with-icon">
                                <span className="text-start">
                                  <p className="text-start mb-0">
                                    <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{val?.brand}</span>
                                  </p>
                                  <p className="text-start mb-0">
                                    <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{val?.series}</span>
                                  </p>
                                  <p className="text-start mb-0 mt-1" style={{ 
                                      fontWeight: 'normal', 
                                      fontSize: '12.6px', 
                                      lineHeight: '12.6px', 
                                      height: '2.2em', 
                                      whiteSpace: 'normal', 
                                      overflow: 'hidden', 
                                    }}>
                                    {val?.model}
                                  </p>
                                </span>
                                <svg
                                  viewBox="0 0 17 17"
                                  className="sc-beqWaB ixusxy hear-icon-mobile"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    fill: val?.isfav ? "red" : "transparent",
                                    stroke: "black",
                                    strokeWidth: val?.isfav ? "0" : 1,
                                    cursor: "pointer",
                                    flexShrink: 0,
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClick(e, val, i);
                                  }}
                                  onTouchStart={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
                                  ></path>
                                </svg>
                              </p>
                              <div> 
                                <div className="bl-text">
                                  <p className="mb-0 my-1" style={{ 
                                      color: '#0b4068',
                                      fontSize: '12.6px', 
                                      lineHeight: '12.6px', 
                                    }}>
                                    Condition:{" "}
                                    {val?.type == 1
                                      ? "New-Retail"
                                      : val?.type == 2
                                      ? " New"
                                      : "Used"}
                                  </p>
                                  <p className="mb-0">{val.condition}</p>
                                </div>

                                {
                                  val?.lowest_ask && val?.benchmark_score ? (
                                    <div>
                                      <p style={{
                                        fontWeight: 'normal',
                                        fontSize: '12.6px',
                                        lineHeight: '12.6px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        height: '1.8em'
                                      }} className="d-flex align-items-center">
                                        {val?.lowest_ask && val?.benchmark_score ? (
                                          <>
                                            <span className="me-1">Deal Score :</span>
                                            <span>{Math.round(parseFloat(val?.benchmark_score / val?.lowest_ask))}</span>
                                            <span
                                              id={`deal-score-tooltip-${val?._id || i}`}
                                              className="d-inline-flex align-items-center justify-content-center"
                                              style={{ cursor: "pointer", flexShrink: 0, marginLeft: '1px', width: '12px', height: '12px' }}
                                            >
                                              <div style={{ transform: 'scale(0.75)', transformOrigin: 'center' }}>
                                                <QuestionMarkSvg />
                                              </div>
                                            </span>
                                            <ReactTooltip
                                              className="custom-tooltip text-center"
                                              anchorId={`deal-score-tooltip-${val?._id || i}`}
                                              place="top"
                                              style={{ maxWidth: "150px", zIndex: 9999 }}
                                              clickable={true}
                                              closeOnScroll={false}
                                              content="Higher Deal Score means better value. It measures performance per dollar using the live price and the model's benchmark score."
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                    </div>
                                  ) : (
                                    ""
                                  )
                                }

                                
                              </div>
                            </div>
                            <div>
                              
                              <div  className="pt-1 pb-2 d-flex align-items-center justify-content-between w-100">
                                <div className="d-flex align-items-center">
                                  {val?.type === 1 ? (
                                    <div className=" mb-0">
                                      {" "}
                                      <h5 className="fw-bold product-price mb-0">${val?.new_retail_website_price}</h5>
                                    </div>
                                  ) : val?.lowest_ask > 0 ? (
                                    <div className="mb-0 d-flex flex-column justify-content-start align-items-start">
                                      <h4 className="fw-bold product-price mb-0">${val?.lowest_ask}</h4>
                                      <span style={{fontSize : "11px" , color : "gray"}}>Lowest Ask</span>
                                    </div>
                                  ) : (
                                    <div className="mb-0 d-flex flex-column justify-content-start align-items-">
                                     
                                      <span style={{color : "gray"}}>Buy Now -</span>
                                    </div>
                                  )}
                                </div>
                                <div className="compare d-flex flex-column align-items-end">
                                  <div className="d-flex flex-column justify-content-between" style={{ width: '100%', position: "relative", overflow: "visible", fontSize: "11px" }}>
                                    <span style={{color : "gray"}}>  {`Highest Offer: ${val?.highest_bid && val?.highest_bid !== 0 && val?.highest_bid !== ""
                                        ? `$${val.highest_bid}`
                                        : "-"
                                      }`}</span>
                                      <button
                                        className="askbidbtn  rounded mb-0 my-1"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          window.open(`/bidask/${val?.slug}`, "_blank")
                                        }

                                        }
                                      style={{ marginBottom: '0', position: "relative" }}

                                    >
                                      Make Offer
                                      <span
                                        className="question_mark ms-1"
                                        onMouseEnter={() =>
                                          handleMouseEnter(val?._id)
                                        }
                                        onMouseLeave={handleMouseLeave}
                                        style={{ position: "relative", display: "inline-block", overflow: "visible", zIndex: 10 }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          id="app-best-deal"
                                          width="16"
                                          height="16"
                                          fillRule="currentColor"
                                          className="bi bi-question-circle-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
                                        </svg>
                                        {tooltipVisible.popUp &&
                                          tooltipVisible.id === val._id && (
                                            <div className="custom-tooltip-new"
                                              style={{
                                                display: "block",
                                                visibility: "visible",
                                                opacity: 1,
                                                position: "absolute",
                                                bottom: "100%",
                                                left: "-400%",
                                                transform: "translateX(-50%)",
                                                marginBottom: "8px",
                                                zIndex: 99999,
                                                background: "#2c2c2c",
                                                color: "#fff",
                                                padding: "8px 10px",
                                                borderRadius: "12px",
                                                width: "220px",
                                                maxWidth: "min(220px, calc(100vw - 30px))",
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                                                pointerEvents: "auto",
                                                whiteSpace: "normal",
                                                lineHeight: "1.5",
                                                fontSize: "13px"
                                              }}>
                                              <p className="tool-tip-content" style={{ position: "relative", color: "#fff", margin: 0, fontSize: "13px", lineHeight: "1.6" }}>
                                               Make an offer at your price. It’s free, you can cancel/delete offers anytime, and you’re only charged if your offer is accepted.
                                              </p>
                                              <div style={{
                                                position: "absolute",
                                                bottom: "-8px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                width: "0",
                                                height: "0",
                                                borderLeft: "8px solid transparent",
                                                borderRight: "8px solid transparent",
                                                borderTop: "8px solid #2c2c2c"
                                              }}></div>
                                            </div>
                                          )}
                                      </span>
                                    </button>

                                  </div>
                                 <div className="d-flex flex-row justify-content-center mt-1">
                                  <input
                                    type="checkbox"
                                    id={`compare-${val._id}`}
                                    checked={val.isCompare}
                                    onChange={(e) => {
                                      handleCompare(e.target.checked, val, i);
                                    }}
                                  />
                                 </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        </div>

                        {/* Mobile Layout - StockX Style */}
                        <div className="product-card-mobile d-md-none">
                          <div
                            className="product-image-mobile-wrapper position-relative"
                            onClick={() =>
                              window.open(`/product/${val?.slug}`, "_blank")
                            }
                          >
                            <span
                              className="d-flex position-absolute"
                              style={{
                                top: "8px",
                                right: "8px",
                                zIndex: 10,
                                fontWeight: "bold",
                                fontSize: "14px",
                                color:
                                  val?.chipset === "AMD"
                                    ? "rgb(186, 0, 21)"
                                    : val?.chipset === "Nvidia"
                                    ? "rgb(114, 179, 0)"
                                    : "inherit",
                              }}
                            >
                              {val?.chipset}
                            </span>
                            <div className="-text-center -image_parent mb-2 mt-2 d-flex align-items-center justify-content-center position-relative">
                              <LazyLoadImage
                                src={`${val?.image[0]}`}
                                effect="blur"
                              />
                            </div>
                          </div>
                          <div className="product-info-mobile">
                            <div>
                              <p className="d-flex align-items-center justify-content-between w-100 mb-0 product-title-with-icon">
                                <span className="text-start" onClick={() => window.open(`/product/${val?.slug}`, "_blank")}>
                                <span className="text-start">
                                  <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{val?.brand}</span>{" "}
                                  <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{val?.series}</span>{" "}
                                  <span style={{ fontSize: '12.6px', lineHeight: '12.6px' }}>{val?.model}</span>
                                </span>
                                </span>
                                <svg
                                  viewBox="0 0 17 17"
                                  className="sc-beqWaB ixusxy hear-icon-mobile"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    fill: val?.isfav ? "red" : "transparent",
                                    stroke: "black",
                                    strokeWidth: val?.isfav ? "0" : 1,
                                    cursor: "pointer",
                                    flexShrink: 0,
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClick(e, val, i);
                                  }}
                                  onTouchStart={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
                                  ></path>
                                </svg>
                              </p>
                              <div>
                                <div className="bl-text">
                                  <p className="mb-0">
                                    Condition:{" "}
                                    {val?.type == 1
                                      ? "New-Retail"
                                      : val?.type == 2
                                      ? " New"
                                      : "Used"}
                                  </p>
                                  <p className="mb-0">{val.condition}</p>
                                </div>
                              </div>
                            </div>
                            <div>
                              <p style={{ fontSize: '10px' }}>
                                {val?.lowest_ask && val?.benchmark_score ? (
                                  <>
                                    Deal Score :
                                    {parseFloat(val?.benchmark_score / val?.lowest_ask).toFixed(2)}{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </p>
                              <div className="d-flex align-items-end justify-content-between mt-3 mb-2 w-100">
                                <div className="d-flex align-items-center">
                                  {val?.type === 1 ? (
                                    <div className="pricevalue mb-0">
                                      {" "}
                                      ${val?.new_retail_website_price}
                                    </div>
                                  ) : val?.lowest_ask > 0 ? (
                                    <div className="pricevalue mb-0">
                                      ${val?.lowest_ask}
                                    </div>
                                  ) : (
                                    <button
                                      className="askbidbtn border rounded mb-0"
                                      onClick={() =>
                                        navigate(`/bidask/${val?.slug}`)
                                      }
                                      style={{ marginBottom: '0 !important' }}
                                    >
                                      bid/ask
                                      <span
                                        className="question_mark ms-1"
                                        onMouseEnter={() =>
                                          handleMouseEnter(val?._id)
                                        }
                                        onMouseLeave={handleMouseLeave}
                                        style={{ position: "relative", display: "inline-block", overflow: "visible", zIndex: 10 }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          id="app-best-deal"
                                          width="16"
                                          height="16"
                                          fillRule="currentColor"
                                          className="bi bi-question-circle-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
                                        </svg>
                                        {tooltipVisible.popUp &&
                                          tooltipVisible.id === val._id && (
                                            <div className="custom-tooltip-new" style={{
                                              display: 'block',
                                              visibility: 'visible',
                                              opacity: 1,
                                              position: 'absolute',
                                              bottom: '100%',
                                              left: '50%',
                                              transform: 'translateX(-50%)',
                                              marginBottom: '8px',
                                              zIndex: 99999,
                                              background: '#2c2c2c',
                                              color: '#fff',
                                              padding: '8px 10px',
                                              borderRadius: '12px',
                                              width: '220px',
                                              maxWidth: 'min(220px, calc(100vw - 30px))',
                                              boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                                              pointerEvents: 'auto',
                                              whiteSpace: 'normal',
                                              lineHeight: '1.5',
                                              fontSize: '12px'
                                            }}>
                                              <p className="tool-tip-content" style={{ position: "relative", color: "#fff", margin: 0, fontSize: "12px", lineHeight: "1.6" }}>
                                                Let the market know at what price
                                                you are committed to make a deal.
                                                <br />
                                                <br />A Bid is the price at which
                                                you are willing to buy an item.
                                                <br />
                                                <br />
                                                An Ask is the price you are
                                                willing to sell an item.
                                                <br />
                                                <br /> Your Bid/Ask will stay
                                                active until someone accept ,
                                                expires or you cancel it.
                                                <br />
                                                <br />
                                                If Someone accept your Bid/Ask
                                                there is no backing out! <br />
                                                <br />
                                                For more information please see
                                                our{" "}
                                                <a
                                                  href="/help/buying-and-Selling-Guide"
                                                  className="text-primary text-decoration-underline"
                                                  style={{ textDecoration: "underline !important", color: "white !important" }} 
                                                  onClick={(e) => e.stopPropagation()}
                                                >
                                                  Buying and Selling Guide
                                                </a>
                                              </p>
                                              <div style={{
                                                position: "absolute",
                                                bottom: "-8px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                width: "0",
                                                height: "0",
                                                borderLeft: "8px solid transparent",
                                                borderRight: "8px solid transparent",
                                                borderTop: "8px solid #2c2c2c"
                                              }}></div>
                                            </div>
                                          )}
                                      </span>
                                    </button>
                                  )}
                                </div>
                                <div className="compare d-flex align-items-center">
                                  <label htmlFor={`compare-${val._id}`} className="mb-0 me-2">Compare</label>
                                  <input
                                    type="checkbox"
                                    id={`compare-${val._id}`}
                                    checked={val.isCompare}
                                    onChange={(e) => {
                                      handleCompare(e.target.checked, val, i);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h4
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        alignItems: "center",
                      }}
                    >
                      No Product Found
                    </h4>
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-end"></div>
              </div>
            )}
            {/* End Showing the Proudct */}
          </Col>
        </Row>

        {showMobileSortSheet && (
          <div
            className="mobile-sort-sheet-wrapper d-lg-none"
            onClick={() => setShowMobileSortSheet(false)}
          >
            <div
              className="mobile-sort-sheet"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mobile-sheet-header">
                <h5 className="mb-0">Sort By</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowMobileSortSheet(false)}
                ></button>
              </div>
              <ul className="list-unstyled mb-0">
                {sortOptions.map((option) => (
                  <li className="filter-section" key={option.value}>
                    <button
                      type="button"
                      className={`mobile-sort-option ${
                        sort === option.value ? "active" : ""
                      }`}
                      onClick={() => {
                        applySort(option.value, option.label);
                        setShowMobileSortSheet(false);
                      }}
                    >
                      {option.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="d-flex align-items-center justify-content-end">
          {totalpages > 1 &&
            mainloader === false &&
            !showConditionLoader &&
            !showChipsetLoader &&
            !showBrandLoader &&
            !showSeriesLoader &&
            !showModalLoader &&
            !showPriceLoader &&
            !sortingLoader && (
              <>
                <Pagination
                  className="order_pagination"
                  count={totalpages}
                  color="primary"
                  hidePrevButton
                  hideNextButton
                  page={page}
                  onChange={handlePageClick}
                />
              </>
            )}
        </div>

          {/* Start Login Modal */}
          <Login
            setSignup={setSignup}
            setForgot={setForgot}
            signup={signup}
            forgot={forgot}
            modal={() => handleClose()}
            show={show}
            setShow={setShow} />
          {/* end Login Modal */}
          <FooterContentSection />

      </Container>
      {/* } */}

      {/* Open Compare Modal  */}
      <Modal
        show={modalShow}
        className="compare-modal custom-model"
        aria-labelledby="contained-modal-title-vcenter"
        data-backdrop="false"
        centered
      >
        <div className="d-flex flex-coloumn align-items-center">
          <Modal.Body className="scrollable-modal-body">
            <div className="model-custom-inner">
              {Compare.map((Compare, i) => {
                return (
                  <div
                    className="inner-pro-cont border p-3 position-relative"
                    id="modal-inner-cont"
                    key={i}
                  >
                    <button
                      className="close-box"
                      onClick={() => handleCloseButton(Compare._id)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-x"
                        viewBox="0 0 16 16"
                      >
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                      </svg>
                    </button>
                    <div className="d-flex gap-2">
                      <div>
                        {Compare?.chipset == "Nvidia" ? (
                          <p className="up-text position-absolute fw-bold toptext" style={{ color: 'rgba(0, 102, 0, 0.5)' }}>
                            {Compare?.chipset}
                          </p>
                        ) : Compare?.chipset == "AMD" ? (
                          <p className="chipset-text position-absolute fw-bold toptext" style={{ color: 'rgba(153, 0, 0, 0.5)' }}>
                            {Compare?.chipset}
                          </p>
                        ) : Compare?.chipset == "AYU" ? (
                          <p className="up-down-text position-absolute fw-bold toptext">
                            {Compare?.chipset}
                          </p>
                        ) : (
                          <p className="chipset-text position-absolute fw-bold toptext">
                            {Compare?.chipset}
                          </p>
                        )}
                        <LazyLoadImage
                          // src={`${imageUrl}${Compare?.image[0]}`}
                          src={
                            Compare?.image[0]?.includes("http")
                              ? Compare?.image[0]
                              : `${imageUrl}${Compare?.image[0]}`
                          }
                          effect="blur"
                        />
                      </div>
                      <div className="custom-model-body text-start">
                        <p className=" w-full mb-0">
                          {Compare?.brand}
                          <div className="w-25 text-end"></div>
                        </p>
                        <p className="mb-0">{Compare?.model}</p>
                        <p className="mb-0">{Compare?.category?.name}</p>
                        <div className="bl-text">
                          <p className="mb-0">
                            Condition:
                            {Compare?.type == 1
                              ? "New-Retail"
                              : Compare?.type == 2
                              ? "New"
                              : "Used"}
                          </p>
                          <p className="mb-0">{Compare?.condition} </p>
                        </div>
                        <h2 className=" fw-bold">
                          {Compare?.type == 1
                            ? "$" + Compare?.new_retail_website_price
                            : Compare?.type == 2
                            ? Compare?.new_second_hand_house_ask
                              ? "$" + Compare?.new_second_hand_house_ask
                              : ""
                            : Compare?.used_house_ask
                            ? "$" + Compare?.used_house_ask
                            : ""}
                        </h2>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center mb-5" style={{minWidth:'100px'}}>
            <div className="comp-minus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="#b8b8b8"
                className="bi bi-dash-circle"
                viewBox="0 0 16 16"
                onClick={() => setModalShow(false)}
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
              </svg>
            </div>

            <Button
              varient="primary"
              className=" comp-bt m-0"
              onClick={() => navigate("/compareBuySell")}
            >
              Compare
            </Button>
            <Button
              className="clear-bt bg-transparent text-blue border-0 m-0 mb-3"
              onClick={() => {
                HandleCompareClear();
              }}
            >
              Clear All
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
      {/* End Compare Modal */}

      {/* Start Compare Button */}
      {Compare[0]?._id && (
        <div className="main_compare_box compare_product_menu">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="compare_product_button">
                  <Button
                    varient="primary"
                    className="px-4"
                    onClick={() => setModalShow(true)}
                  >
                    Compare
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      {/* end Compare Button */}

      <Footer />
    </div>
   </>
  );
}
